import { $ as e, $t as t, A as n, At as r, B as i, Bt as a, C as o, Ct as s, D as c, Dt as l, E as u, Et as d, F as f, Ft as p, G as m, Gt as h, H as ee, Ht as g, I as te, It as _, J as v, Jt as ne, K as re, Kt as ie, L as y, Lt as b, M as ae, Mt as oe, N as se, Nt as ce, O as le, Ot as ue, P as de, Pt as fe, Q as pe, Qt as me, R as he, Rt as ge, S as _e, St as ve, T as ye, Tt as be, U as xe, Ut as Se, V as Ce, Vt as we, W as Te, Wt as Ee, X as De, Xt as Oe, Y as ke, Yt as Ae, Z as je, Zt as Me, _ as Ne, _t as Pe, a as Fe, at as Ie, b as Le, bt as Re, c as ze, ct as Be, d as Ve, dt as He, et as Ue, f as We, ft as Ge, g as Ke, gt as qe, h as Je, ht as Ye, i as Xe, it as Ze, j as Qe, jt as $e, k as et, kt as tt, l as nt, lt as rt, m as it, mt as at, n as ot, nn as st, nt as ct, o as lt, ot as ut, p as dt, pt as ft, q as pt, qt as mt, r as ht, rt as gt, s as _t, st as vt, t as yt, tn as bt, tt as xt, u as St, ut as Ct, v as wt, vt as Tt, w as Et, wt as Dt, x as Ot, xt as kt, y as At, yt as jt, z as Mt, zt as Nt } from "./sdk.gen-DVdZJ1Om.js";
import { $ as Pt, A as Ft, B as It, C as Lt, Ct as Rt, D as zt, E as Bt, F as Vt, G as Ht, H as Ut, I as Wt, J as Gt, K as Kt, L as qt, M as Jt, N as Yt, O as Xt, P as Zt, Q as Qt, R as $t, S as en, St as tn, T as nn, U as rn, V as an, W as on, X as sn, Y as cn, Z as ln, _ as un, _t as dn, a as fn, at as pn, b as mn, bt as hn, c as gn, ct as _n, d as vn, dt as yn, et as bn, f as xn, ft as Sn, g as Cn, gt as wn, h as Tn, ht as En, i as Dn, it as On, j as kn, k as An, l as jn, lt as Mn, m as Nn, mt as Pn, n as Fn, nt as In, ot as Ln, p as Rn, pt as zn, q as Bn, r as Vn, rt as Hn, st as Un, t as Wn, tt as Gn, u as x, ut as Kn, v as qn, vt as Jn, w as Yn, wt as Xn, x as Zn, xt as Qn, y as $n, yt as er, z as tr } from "./shippablePackages-Bu2bHzjL.js";
import { t as nr } from "./useOrderService-BpnFtWsM.js";
//#region \0rolldown/runtime.js
var rr = Object.defineProperty, ir = /* @__PURE__ */ ((e, t) => {
	let n = {};
	for (var r in e) rr(n, r, {
		get: e[r],
		enumerable: !0
	});
	return t || rr(n, Symbol.toStringTag, { value: "Module" }), n;
})({}), ar = (e, t) => {
	let n = e.message;
	if (n) switch (n.case) {
		case fn.OrderCreated:
			t.onCreated?.(n.value);
			break;
		case fn.OrderUpdated:
			t.onUpdated?.(n.value);
			break;
		case fn.OrderDeleted:
			t.onDeleted?.(n.value);
			break;
		case fn.OrderRulesEvaluated:
			t.onRuleEvaluated?.(n.value);
			break;
	}
}, or = {
	CommercialGoods: "COMMERCIAL_GOODS",
	CommercialSample: "COMMERCIAL_SAMPLE",
	Documents: "DOCUMENTS",
	Gift: "GIFT",
	ReturnedGoods: "RETURNED_GOODS"
}, sr = {
	PickingAndPacking: "PICKING_AND_PACKING",
	Discpatching: "DISPATCHING",
	Untraceable: "UNTRACEABLE",
	Sorting: "SORTING",
	Distributing: "DISTRIBUTING",
	Delivered: "DELIVERED"
}, cr = (e) => e.type === "BUSINESS" || "company" in e && typeof e.company == "string" && e.company.length > 0, lr = (e) => e.type === "PRIVATE" || "name" in e && typeof e.name == "string";
//#endregion
//#region src/typeguards/label.ts
function ur(e) {
	return e !== void 0 && "barcode" in e;
}
function dr(e) {
	return e !== void 0 && !("barcode" in e);
}
//#endregion
//#region ../../libs/types/dist/index.js
var S = {
	PostNl: 1,
	Bpost: 2,
	CheapCargo: 3,
	Dpd: 4,
	Instabox: 5,
	Dhl: 6,
	Bol: 7,
	Ups: 8,
	DhlForYou: 9,
	DhlParcelConnect: 10,
	DhlEuroPlus: 11,
	UpsStandard: 12,
	UpsExpressSaver: 13,
	Gls: 14,
	Brt: 15,
	Trunkrs: 16,
	InPost: 17,
	PosteItaliane: 18,
	Spring: 19,
	ViaTim: 20
}, C = {
	PostNl: "postnl",
	POSTNL: "POSTNL",
	Bpost: "bpost",
	BPOST: "BPOST",
	CheapCargo: "cheapcargo",
	CHEAP_CARGO: "CHEAP_CARGO",
	Dpd: "dpd",
	DPD: "DPD",
	Instabox: "instabox",
	INSTABOX: "INSTABOX",
	Dhl: "dhl",
	BolCom: "bol.com",
	Bol: "bol",
	BOL: "BOL",
	Ups: "ups",
	UPS: "ups",
	DHL: "DHL",
	DhlForYou: "dhlforyou",
	DHL_FOR_YOU: "DHL_FOR_YOU",
	DhlParcelConnect: "dhlparcelconnect",
	DHL_PARCEL_CONNECT: "DHL_PARCEL_CONNECT",
	DhlEuroPlus: "dhleuroplus",
	DHL_EUROPLUS: "DHL_EUROPLUS",
	UpsStandard: "upsstandard",
	UPS_STANDARD: "UPS_STANDARD",
	UpsExpressSaver: "upsexpresssaver",
	UPS_EXPRESS_SAVER: "UPS_EXPRESS_SAVER",
	Gls: "gls",
	GLS: "GLS",
	Brt: "brt",
	BRT: "BRT",
	Trunkrs: "trunkrs",
	TRUNKRS: "TRUNKRS",
	InPost: "inpost",
	INPOST: "INPOST",
	PosteItaliane: "posteitaliane",
	POSTE_ITALIANE: "POSTE_ITALIANE",
	Spring: "spring",
	SPRING: "SPRING",
	ViaTim: "viatim",
	VIA_TIM: "VIA_TIM"
};
S.Dhl, S.Instabox, S.PostNl, C.PostNl, S.Bpost, C.Bpost, S.CheapCargo, C.CheapCargo, S.Dpd, C.Dpd, S.Instabox, C.Instabox, S.Dhl, C.Dhl, S.Bol, C.Bol, S.Ups, C.Ups, S.DhlForYou, C.DhlForYou, S.DhlParcelConnect, C.DhlParcelConnect, S.DhlEuroPlus, C.DhlEuroPlus, S.UpsStandard, C.UpsStandard, S.UpsExpressSaver, C.UpsExpressSaver, S.Gls, C.Gls, S.Brt, C.Brt, S.Trunkrs, C.Trunkrs, S.InPost, C.InPost, S.PosteItaliane, C.PosteItaliane, S.Spring, C.Spring, S.ViaTim, C.ViaTim, S.PostNl, C.POSTNL, S.Bpost, C.BPOST, S.CheapCargo, C.CHEAP_CARGO, S.Dpd, C.DPD, S.Instabox, C.INSTABOX, S.Dhl, C.DHL, S.Bol, C.BOL, S.Ups, C.UPS, S.DhlForYou, C.DHL_FOR_YOU, S.DhlParcelConnect, C.DHL_PARCEL_CONNECT, S.DhlEuroPlus, C.DHL_EUROPLUS, S.UpsStandard, C.UPS_STANDARD, S.UpsExpressSaver, C.UPS_EXPRESS_SAVER, S.Gls, C.GLS, S.Brt, C.BRT, S.Trunkrs, C.TRUNKRS, S.InPost, C.INPOST, S.PosteItaliane, C.POSTE_ITALIANE, S.Spring, C.SPRING, S.ViaTim, C.VIA_TIM, C.PostNl, S.PostNl, C.POSTNL, S.PostNl, C.Bpost, S.Bpost, C.BPOST, S.Bpost, C.CheapCargo, S.CheapCargo, C.CHEAP_CARGO, S.CheapCargo, C.Dpd, S.Dpd, C.DPD, S.Dpd, C.Instabox, S.Instabox, C.Dhl, S.Dhl, C.BolCom, S.Bol, C.Bol, S.Bol, C.BOL, S.Bol, C.Ups, S.Ups, C.DhlForYou, S.DhlForYou, C.DHL_FOR_YOU, S.DhlForYou, C.DhlParcelConnect, S.DhlParcelConnect, C.DHL_PARCEL_CONNECT, S.DhlParcelConnect, C.DhlEuroPlus, S.DhlEuroPlus, C.DHL_EUROPLUS, S.DhlEuroPlus, C.UpsStandard, S.UpsStandard, C.UPS_STANDARD, S.UpsStandard, C.UpsExpressSaver, S.UpsExpressSaver, C.UPS_EXPRESS_SAVER, S.UpsExpressSaver, C.Gls, S.Gls, C.GLS, S.Gls, C.Brt, S.Brt, C.BRT, S.Brt, C.Trunkrs, S.Trunkrs, C.TRUNKRS, S.Trunkrs, C.InPost, S.InPost, C.INPOST, S.InPost, C.PosteItaliane, S.PosteItaliane, C.POSTE_ITALIANE, S.PosteItaliane, C.Spring, S.Spring, C.SPRING, S.Spring, C.ViaTim, S.ViaTim, C.VIA_TIM, S.ViaTim, S.PostNl, S.Bpost, S.CheapCargo, S.Dpd, S.Instabox, S.Dhl, S.Bol, S.Ups, S.DhlForYou, S.DhlParcelConnect, S.DhlEuroPlus, S.UpsStandard, S.UpsExpressSaver, S.Gls, S.Brt, S.Trunkrs, S.InPost, S.PosteItaliane, S.ViaTim;
var w = {
	Afghanistan: "AF",
	AlandIslands: "AX",
	Albania: "AL",
	Algeria: "DZ",
	AmericanSamoa: "AS",
	AmericanVirginIslands: "VI",
	Andorra: "AD",
	Angola: "AO",
	Anguilla: "AI",
	Antarctica: "AQ",
	AntiguaAndBarbuda: "AG",
	Argentina: "AR",
	Armenia: "AM",
	Aruba: "AW",
	Australia: "AU",
	Austria: "AT",
	Azerbaijan: "AZ",
	Bahamas: "BS",
	Bahrain: "BH",
	Bangladesh: "BD",
	Barbados: "BB",
	Belarus: "BY",
	Belgium: "BE",
	Belize: "BZ",
	Benin: "BJ",
	Bermuda: "BM",
	Bhutan: "BT",
	Bolivia: "BO",
	BonaireSintEustatiusAndSaba: "BQ",
	BosniaAndHerzegovina: "BA",
	Botswana: "BW",
	BouvetIsland: "BV",
	Brazil: "BR",
	BritishIndianOceanTerritory: "IO",
	BritishVirginIslands: "VG",
	BruneiDarussalam: "BN",
	Bulgaria: "BG",
	BurkinaFaso: "BF",
	Burundi: "BI",
	CaboVerde: "CV",
	Cambodia: "KH",
	Cameroon: "CM",
	Canada: "CA",
	CanaryIslands: "IC",
	CaymanIslands: "KY",
	CentralAfricanRepublic: "CF",
	Chad: "TD",
	Chile: "CL",
	China: "CN",
	ChristmasIsland: "CX",
	CocosIslands: "CC",
	Colombia: "CO",
	Comoros: "KM",
	CongoBrazzaville: "CG",
	CongoKinshasa: "CD",
	CookIslands: "CK",
	CostaRica: "CR",
	CoteDIvoire: "CI",
	Croatia: "HR",
	Cuba: "CU",
	Curacao: "CW",
	Cyprus: "CY",
	CzechRepublic: "CZ",
	Denmark: "DK",
	Djibouti: "DJ",
	Dominica: "DM",
	DominicanRepublic: "DO",
	DutchAntilles: "AN",
	Ecuador: "EC",
	Egypt: "EG",
	ElSalvador: "SV",
	EquatorialGuinea: "GQ",
	Eritrea: "ER",
	Estonia: "EE",
	Eswatini: "SZ",
	Ethiopia: "ET",
	FalklandIslands: "FK",
	FaroeIslands: "FO",
	Fiji: "FJ",
	Finland: "FI",
	France: "FR",
	FrenchGuiana: "GF",
	FrenchPolynesia: "PF",
	FrenchSouthernTerritories: "TF",
	Gabon: "GA",
	Gambia: "GM",
	Georgia: "GE",
	Germany: "DE",
	Ghana: "GH",
	Gibraltar: "GI",
	Greece: "GR",
	Greenland: "GL",
	Grenada: "GD",
	Guadeloupe: "GP",
	Guam: "GU",
	Guatemala: "GT",
	Guernsey: "GG",
	Guinea: "GN",
	GuineaBissau: "GW",
	Guyana: "GY",
	Haiti: "HT",
	HeardIslandAndMcdonaldIslands: "HM",
	HolySee: "VA",
	Honduras: "HN",
	HongKong: "HK",
	Hungary: "HU",
	Iceland: "IS",
	India: "IN",
	Indonesia: "ID",
	Iran: "IR",
	Iraq: "IQ",
	Ireland: "IE",
	IsleOfMan: "IM",
	Israel: "IL",
	Italy: "IT",
	Jamaica: "JM",
	Japan: "JP",
	Jersey: "JE",
	Jordan: "JO",
	Kazakhstan: "KZ",
	Kenya: "KE",
	Kiribati: "KI",
	KoreaPeoplesDemocraticRepublic: "KP",
	KoreaRepublic: "KR",
	Kosovo: "XK",
	Kuwait: "KW",
	Kyrgyzstan: "KG",
	Laos: "LA",
	Latvia: "LV",
	Lebanon: "LB",
	Lesotho: "LS",
	Liberia: "LR",
	Libya: "LY",
	Liechtenstein: "LI",
	Lithuania: "LT",
	Luxembourg: "LU",
	Macao: "MO",
	Madagascar: "MG",
	Malawi: "MW",
	Malaysia: "MY",
	Maldives: "MV",
	Mali: "ML",
	Malta: "MT",
	MarshallIslands: "MH",
	Martinique: "MQ",
	Mauritania: "MR",
	Mauritius: "MU",
	Mayotte: "YT",
	Mexico: "MX",
	Micronesia: "FM",
	Moldova: "MD",
	Monaco: "MC",
	Mongolia: "MN",
	Montenegro: "ME",
	Montserrat: "MS",
	Morocco: "MA",
	Mozambique: "MZ",
	Myanmar: "MM",
	Namibia: "NA",
	Nauru: "NR",
	Nepal: "NP",
	Netherlands: "NL",
	NewCaledonia: "NC",
	NewZealand: "NZ",
	Nicaragua: "NI",
	Niger: "NE",
	Nigeria: "NG",
	Niue: "NU",
	NorfolkIsland: "NF",
	NorthMacedonia: "MK",
	NorthernMarianaIslands: "MP",
	Norway: "NO",
	Oman: "OM",
	Pakistan: "PK",
	Palau: "PW",
	Palestine: "PS",
	Panama: "PA",
	PapuaNewGuinea: "PG",
	Paraguay: "PY",
	Peru: "PE",
	Philippines: "PH",
	Pitcairn: "PN",
	Poland: "PL",
	Portugal: "PT",
	PuertoRico: "PR",
	Qatar: "QA",
	Reunion: "RE",
	Romania: "RO",
	RussianFederation: "RU",
	Rwanda: "RW",
	SaintBarthelemy: "BL",
	SaintHelena: "SH",
	SaintKittsAndNevis: "KN",
	SaintLucia: "LC",
	SaintMartin: "MF",
	SaintPierreAndMiquelon: "PM",
	SaintVincentAndTheGrenadines: "VC",
	Samoa: "WS",
	SanMarino: "SM",
	SaoTomeAndPrincipe: "ST",
	SaudiArabia: "SA",
	Senegal: "SN",
	Serbia: "RS",
	Seychelles: "SC",
	SierraLeone: "SL",
	Singapore: "SG",
	SintMaarten: "SX",
	Slovakia: "SK",
	Slovenia: "SI",
	SolomonIslands: "SB",
	Somalia: "SO",
	SouthAfrica: "ZA",
	SouthGeorgiaAndTheSouthSandwichIslands: "GS",
	SouthSudan: "SS",
	Spain: "ES",
	SriLanka: "LK",
	Sudan: "SD",
	Suriname: "SR",
	SvalbardAndJanMayen: "SJ",
	Sweden: "SE",
	Switzerland: "CH",
	SyrianArabRepublic: "SY",
	Taiwan: "TW",
	Tajikistan: "TJ",
	Tanzania: "TZ",
	Thailand: "TH",
	TimorLeste: "TL",
	Togo: "TG",
	Tokelau: "TK",
	Tonga: "TO",
	TrinidadAndTobago: "TT",
	Tunisia: "TN",
	Turkey: "TR",
	Turkmenistan: "TM",
	TurksAndCaicosIslands: "TC",
	Tuvalu: "TV",
	Uganda: "UG",
	Ukraine: "UA",
	UnitedArabEmirates: "AE",
	UnitedKingdom: "GB",
	UnitedStatesMinorOutlyingIslands: "UM",
	UnitedStatesOfAmerica: "US",
	Uruguay: "UY",
	Uzbekistan: "UZ",
	Vanuatu: "VU",
	Venezuela: "VE",
	Vietnam: "VN",
	WallisAndFutuna: "WF",
	WesternSahara: "EH",
	Yemen: "YE",
	Zambia: "ZM",
	Zimbabwe: "ZW"
};
w.Austria, w.Belgium, w.Bulgaria, w.Croatia, w.Cyprus, w.CzechRepublic, w.Denmark, w.Estonia, w.Finland, w.France, w.Germany, w.Greece, w.Hungary, w.Ireland, w.Italy, w.Latvia, w.Lithuania, w.Luxembourg, w.Malta, w.Netherlands, w.Poland, w.Portugal, w.Romania, w.Slovakia, w.Slovenia, w.Spain, w.Sweden, Object.values(w), w.Angola, w.AntiguaAndBarbuda, w.Aruba, w.Bahamas, w.Belize, w.Benin, w.Bermuda, w.BonaireSintEustatiusAndSaba, w.Botswana, w.BurkinaFaso, w.Burundi, w.Cameroon, w.CanaryIslands, w.CentralAfricanRepublic, w.Comoros, w.CongoBrazzaville, w.CongoKinshasa, w.CoteDIvoire, w.Curacao, w.Djibouti, w.Dominica, w.DutchAntilles, w.EquatorialGuinea, w.Eritrea, w.Fiji, w.Gabon, w.Gambia, w.Ghana, w.Grenada, w.Guyana, w.HongKong, w.Kiribati, w.KoreaPeoplesDemocraticRepublic, w.Macao, w.Malawi, w.Mali, w.Mauritania, w.Nauru, w.Qatar, w.Rwanda, w.SaintKittsAndNevis, w.SaoTomeAndPrincipe, w.Seychelles, w.SierraLeone, w.SintMaarten, w.Suriname, w.SyrianArabRepublic, w.TimorLeste, w.Togo, w.Tonga, w.Tuvalu, w.Uganda, w.UnitedArabEmirates, w.Vanuatu, w.Yemen, w.Zimbabwe, w.Austria, w.Belgium, w.Bulgaria, w.Croatia, w.CzechRepublic, w.Estonia, w.Finland, w.France, w.Germany, w.Greece, w.Hungary, w.Ireland, w.Italy, w.Latvia, w.Lithuania, w.Luxembourg, w.Malta, w.Netherlands, w.Portugal, w.Romania, w.Slovakia, w.Slovenia, w.Spain, w.UnitedKingdom, w.Denmark, w.Germany, w.Sweden;
var T = {
	EarlyMorning: 8,
	Morning: 1,
	Standard: 2,
	Evening: 3,
	Pickup: 4,
	PickupExpress: 5,
	SameDayDelivery: 6,
	Express: 7
}, E = {
	EarlyMorning: "early_morning",
	Morning: "morning",
	Standard: "standard",
	Evening: "evening",
	Pickup: "pickup",
	PickupExpress: "pickup_express",
	SameDayDelivery: "same_day",
	Express: "express"
}, D = {
	EarlyMorning: "EARLY_MORNING_DELIVERY",
	Morning: "MORNING_DELIVERY",
	Standard: "STANDARD_DELIVERY",
	Evening: "EVENING_DELIVERY",
	Pickup: "PICKUP_DELIVERY",
	PickupExpress: "PICKUP_EXPRESS_DELIVERY",
	SameDayDelivery: "SAME_DAY_DELIVERY",
	Express: "EXPRESS_DELIVERY"
};
T.EarlyMorning, E.EarlyMorning, T.Morning, E.Morning, T.Standard, E.Standard, T.Evening, E.Evening, T.Pickup, E.Pickup, T.PickupExpress, E.PickupExpress, T.SameDayDelivery, E.SameDayDelivery, T.Express, E.Express, E.EarlyMorning, T.EarlyMorning, E.Morning, T.Morning, E.Standard, T.Standard, E.Evening, T.Evening, E.Pickup, T.Pickup, E.PickupExpress, T.PickupExpress, E.SameDayDelivery, T.SameDayDelivery, E.Express, T.Express, T.EarlyMorning, D.EarlyMorning, T.Morning, D.Morning, T.Standard, D.Standard, T.Evening, D.Evening, T.Pickup, D.Pickup, T.PickupExpress, D.PickupExpress, T.SameDayDelivery, D.SameDayDelivery, T.Express, D.Express, D.EarlyMorning, E.EarlyMorning, D.Morning, E.Morning, D.Standard, E.Standard, D.Evening, E.Evening, D.Pickup, E.Pickup, D.PickupExpress, E.PickupExpress, D.SameDayDelivery, E.SameDayDelivery, D.Express, E.Express, T.EarlyMorning, T.Morning, T.Standard, T.Evening, T.Pickup, T.PickupExpress, T.SameDayDelivery, T.Express, { Vasco: 1 }.Vasco, { Vasco: "vasco" }.Vasco;
var O = {
	Sunday: 0,
	Monday: 1,
	Tuesday: 2,
	Wednesday: 3,
	Thursday: 4,
	Friday: 5,
	Saturday: 6
}, k = {
	Sunday: "sunday",
	Monday: "monday",
	Tuesday: "tuesday",
	Wednesday: "wednesday",
	Thursday: "thursday",
	Friday: "friday",
	Saturday: "saturday"
};
k.Sunday, O.Sunday, k.Monday, O.Monday, k.Tuesday, O.Tuesday, k.Wednesday, O.Wednesday, k.Thursday, O.Thursday, k.Friday, O.Friday, k.Saturday, O.Saturday, O.Sunday, k.Sunday, O.Monday, k.Monday, O.Tuesday, k.Tuesday, O.Wednesday, k.Wednesday, O.Thursday, k.Thursday, O.Friday, k.Friday, O.Saturday, k.Saturday;
var fr = {
	Bytes: "B",
	Kilobytes: "KB",
	Megabytes: "MB",
	Gigabytes: "GB",
	Terabytes: "TB"
};
fr.Bytes, fr.Kilobytes, fr.Megabytes, fr.Gigabytes, fr.Terabytes;
var pr = {
	Bol: 1,
	Exact: 2,
	Amazon: 6,
	Wix: 8,
	ExactDe: 10,
	Etsy: 11
}, mr = {
	Bol: "bol_dot_com",
	Wix: "wix",
	Exact: "exact",
	ExactDe: "exact_de",
	Amazon: "amazon",
	Etsy: "etsy"
};
pr.Bol, mr.Bol, pr.Exact, mr.Exact, pr.Amazon, mr.Amazon, pr.Wix, mr.Wix, pr.ExactDe, mr.ExactDe, pr.Etsy, mr.Etsy, mr.Bol, pr.Bol, mr.Exact, pr.Exact, mr.Amazon, pr.Amazon, mr.Wix, pr.Wix, mr.ExactDe, pr.ExactDe, mr.Etsy, pr.Etsy;
var A = {
	Unpaid: 1,
	Due: 101,
	DuePrepayment: 102,
	Reminder1: 106,
	Reminder2: 111,
	Dun: 116,
	Collection: 121,
	Instalments: 126,
	PaymentArrangement: 127,
	Dispute: 128,
	LegalProcedure: 129,
	Insolvency: 130,
	WriteOff: 131,
	Pending: 301,
	Cancelled: 401,
	Paid: 501,
	PaidOnline: 506,
	PaidAutomatic: 511,
	PaidCredit: 597,
	PaidZeroItems: 598,
	InvoiceWith0InvoiceItemsPaidZeroBalance: 599
}, j = {
	Unpaid: "Unpaid",
	Due: "Due",
	DuePrepayment: "DuePrepayment",
	Reminder1: "Reminder1",
	Reminder2: "Reminder2",
	Dun: "Dun",
	Collection: "Collection",
	Instalments: "Instalments",
	PaymentArrangement: "PaymentArrangement",
	Dispute: "Dispute",
	LegalProcedure: "LegalProcedure",
	Insolvency: "Insolvency",
	WriteOff: "WriteOff",
	Pending: "Pending",
	Cancelled: "Cancelled",
	Paid: "Paid",
	PaidOnline: "PaidOnline",
	PaidAutomatic: "PaidAutomatic",
	PaidCredit: "PaidCredit",
	PaidZeroItems: "PaidZeroItems",
	PaidZeroBalance: "PaidZeroBalance"
};
A.Unpaid, j.Unpaid, A.Due, j.Due, A.DuePrepayment, j.DuePrepayment, A.Reminder1, j.Reminder1, A.Reminder2, j.Reminder2, A.Dun, j.Dun, A.Collection, j.Collection, A.Instalments, j.Instalments, A.PaymentArrangement, j.PaymentArrangement, A.Dispute, j.Dispute, A.LegalProcedure, j.LegalProcedure, A.Insolvency, j.Insolvency, A.WriteOff, j.WriteOff, A.Pending, j.Pending, A.Cancelled, j.Cancelled, A.Paid, j.Paid, A.PaidOnline, j.PaidOnline, A.PaidAutomatic, j.PaidAutomatic, A.PaidCredit, j.PaidCredit, A.PaidZeroItems, j.PaidZeroItems, A.InvoiceWith0InvoiceItemsPaidZeroBalance, j.PaidZeroBalance, A.Due, A.Reminder1, A.Reminder2, A.Dun, A.Collection, A.Instalments, A.PaymentArrangement, A.Dispute, A.Paid, A.PaidOnline, A.PaidAutomatic, A.PaidCredit, A.PaidZeroItems;
var hr = {
	Gram: "g",
	Kilogram: "kg"
};
hr.Gram, hr.Kilogram;
var gr = {
	Millimeter: "mm",
	Centimeter: "cm",
	Meter: "m"
};
gr.Millimeter, gr.Centimeter, gr.Meter;
var _r = {
	Eu: "EU",
	HomeCountry: "Home Country",
	Row: "ROW",
	Cd: "CD",
	World: "WERELD"
}, vr = {
	PendingConcept: 1,
	PendingRegistered: 2,
	EnRouteHandedToCarrier: 3,
	EnRouteSorting: 4,
	EnRouteDistribution: 5,
	EnRouteCustoms: 6,
	DeliveredAtRecipient: 7,
	DeliveredReadyForPickup: 8,
	DeliveredPackagePickedUp: 9,
	DeliveredReturnShipmentReadyForPickup: 10,
	DeliveredReturnShipmentPackagePickedUp: 11,
	PrintedLetter: 12,
	InactiveCredited: 13,
	PrintedDigitalStamp: 14,
	Expired: 16,
	Cancelled: 17,
	InactiveConcept: 30,
	InactiveRegistered: 31,
	InactiveEnRouteHandedToCarrier: 32,
	InactiveEnRouteSorting: 33,
	InactiveEnRouteDistribution: 34,
	InactiveEnRouteCustoms: 35,
	InactiveDeliveredAtRecipient: 36,
	InactiveDeliveredReadyForPickup: 37,
	InactiveDeliveredPackagePickedUp: 38
};
vr.PendingConcept, vr.PendingRegistered, vr.EnRouteHandedToCarrier, vr.EnRouteSorting, vr.EnRouteDistribution, vr.EnRouteCustoms, vr.DeliveredReadyForPickup, vr.DeliveredAtRecipient, vr.DeliveredPackagePickedUp;
var M = {
	Light: "light",
	Start: "start",
	Plus: "plus",
	Premium: "premium",
	Max: "max"
}, yr = {
	Light: 0,
	Start: 1,
	Plus: 2,
	Premium: 3,
	Max: 4
};
yr.Light, M.Light, yr.Start, M.Start, yr.Plus, M.Plus, yr.Premium, M.Premium, yr.Max, M.Max, M.Light, yr.Light, M.Start, yr.Start, M.Plus, yr.Plus, M.Premium, yr.Premium, M.Max, yr.Max;
var br = {
	Start: 4800,
	Plus: 4801,
	Premium: 4802,
	Max: 4803
}, xr = {
	Start: M.Start,
	Plus: M.Plus,
	Premium: M.Premium,
	Max: M.Max
};
br.Start, xr.Start, br.Plus, xr.Plus, br.Premium, xr.Premium, br.Max, xr.Max, xr.Start, br.Start, xr.Plus, br.Plus, xr.Premium, br.Premium, xr.Max, br.Max;
var Sr = {
	Start: 4700,
	Plus: 4701,
	Premium: 4702,
	Max: 4703
}, Cr = {
	Start: M.Start,
	Plus: M.Plus,
	Premium: M.Premium,
	Max: M.Max
};
Sr.Start, Cr.Start, Sr.Plus, Cr.Plus, Sr.Premium, Cr.Premium, Sr.Max, Cr.Max, Cr.Start, Sr.Start, Cr.Plus, Sr.Plus, Cr.Premium, Sr.Premium, Cr.Max, Sr.Max;
var wr = {
	Light: 4610,
	Start: 4611,
	Plus: 4612,
	Premium: 4613,
	Max: 4614
}, Tr = {
	Light: M.Light,
	Start: M.Start,
	Plus: M.Plus,
	Premium: M.Premium,
	Max: M.Max
};
wr.Light, Tr.Light, wr.Start, Tr.Start, wr.Plus, Tr.Plus, wr.Premium, Tr.Premium, wr.Max, Tr.Max, Tr.Light, wr.Light, Tr.Start, wr.Start, Tr.Plus, wr.Plus, Tr.Premium, wr.Premium, Tr.Max, wr.Max;
var Er = {
	Start: 4615,
	Plus: 4616,
	Premium: 4617,
	Max: 4618
}, Dr = {
	Start: M.Start,
	Plus: M.Plus,
	Premium: M.Premium,
	Max: M.Max
};
Er.Start, Dr.Start, Er.Plus, Dr.Plus, Er.Premium, Dr.Premium, Er.Max, Dr.Max, Dr.Start, Er.Start, Dr.Plus, Er.Plus, Dr.Premium, Er.Premium, Dr.Max, Er.Max;
var N = {
	MyParcel: 1,
	Flespakket: 2,
	SendMyParcel: 3,
	DeliverDutch: 4,
	PostNlPlugin: 5,
	MyParcelIt: 6
}, Or = {
	MyParcel: "myparcel",
	Flespakket: "flespakket",
	SendMyParcel: "belgie",
	DeliverDutch: "deliver-dutch",
	PostNlPlugin: "postnl-plugin",
	MyParcelIt: "italie"
}, kr = {
	Default: "default",
	MyParcelNl: "myparcel-nederland",
	MyParcelBe: "myparcel-belgie",
	MyParcelIt: "myparcel-italie",
	DeliverDutch: "deliver-dutch",
	PostNlPlugin: "postnl-plugin"
};
N.MyParcel, Or.MyParcel, N.Flespakket, Or.Flespakket, N.SendMyParcel, Or.SendMyParcel, N.MyParcelIt, Or.MyParcelIt, N.DeliverDutch, Or.DeliverDutch, N.PostNlPlugin, Or.PostNlPlugin, N.MyParcel, kr.MyParcelNl, N.Flespakket, kr.MyParcelNl, N.SendMyParcel, kr.MyParcelBe, N.MyParcelIt, kr.MyParcelIt, N.DeliverDutch, kr.DeliverDutch, N.PostNlPlugin, kr.PostNlPlugin, kr.MyParcelNl, N.MyParcel, kr.MyParcelBe, N.SendMyParcel, kr.MyParcelIt, N.MyParcelIt, kr.MyParcelNl, _r.HomeCountry, w.Netherlands, _r.Eu, _r.Row, w.Belgium, kr.MyParcelBe, _r.HomeCountry, w.Belgium, w.Netherlands, _r.Eu, _r.Row, kr.MyParcelBe, _r.HomeCountry, w.Belgium, _r.Eu, _r.Row, kr.MyParcelNl, _r.HomeCountry, w.Netherlands, _r.Eu, _r.Row, kr.MyParcelNl, _r.HomeCountry, w.Netherlands, w.Belgium, w.Luxembourg, S.Bpost, S.PostNl, S.DhlForYou, S.DhlParcelConnect, S.DhlEuroPlus, S.Ups, S.UpsStandard, S.UpsExpressSaver;
var P = {
	Package: 1,
	Mailbox: 2,
	Letter: 3,
	DigitalStamp: 4,
	Pallet: 5,
	PackageSmall: 6,
	Envelope: 7
}, F = {
	Package: "package",
	Mailbox: "mailbox",
	Letter: "letter",
	DigitalStamp: "digital_stamp",
	Pallet: "pallet",
	PackageSmall: "package_small",
	Envelope: "envelope"
};
P.Package, F.Package, P.Mailbox, F.Mailbox, P.Letter, F.Letter, P.DigitalStamp, F.DigitalStamp, P.Pallet, F.Pallet, P.PackageSmall, F.PackageSmall, P.Envelope, F.Envelope, F.Package, P.Package, F.Mailbox, P.Mailbox, F.Letter, P.Letter, F.DigitalStamp, P.DigitalStamp, F.Pallet, P.Pallet, F.PackageSmall, P.PackageSmall, F.Envelope, P.Envelope;
var I = {
	DIGITAL_STAMP: "DIGITAL_STAMP",
	ENVELOPE: "ENVELOPE",
	MAILBOX: "MAILBOX",
	PACKAGE: "PACKAGE",
	PALLET: "PALLET",
	SMALL_PACKAGE: "SMALL_PACKAGE",
	UNFRANKED: "UNFRANKED"
};
P.Package, I.PACKAGE, P.Mailbox, I.MAILBOX, P.Letter, I.UNFRANKED, P.DigitalStamp, I.DIGITAL_STAMP, P.Pallet, I.PALLET, P.PackageSmall, I.SMALL_PACKAGE, P.Envelope, I.ENVELOPE, I.PACKAGE, P.Package, I.MAILBOX, P.Mailbox, I.UNFRANKED, P.Letter, I.DIGITAL_STAMP, P.DigitalStamp, I.PALLET, P.Pallet, I.SMALL_PACKAGE, P.PackageSmall, I.ENVELOPE, P.Envelope, P.Package, P.Mailbox, P.Letter, P.DigitalStamp, P.Pallet, P.PackageSmall, P.Envelope;
var L = {
	PendingConcept: 1,
	PendingRegistered: 2,
	EnrouteHandedToCarrier: 3,
	EnrouteSorting: 4,
	EnrouteDistribution: 5,
	DeliveredAtCustoms: 6,
	DeliveredAtRecipient: 7,
	DeliveredReadyForPickup: 8,
	DeliveredPackagePickedUp: 9,
	DeliveredReturnShipmentReadyForPickup: 10,
	DeliveredReturnShipmentPackagePickedUp: 11,
	PrintedUnpaidLabel: 12,
	PrintedLetter: 12,
	Credited: 13,
	PrintedStamp: 14,
	PrintedDigitalStamp: 14,
	Expired: 16,
	Cancelled: 17,
	PrintedUntrackedShipment: 18,
	DeliveredAtAgreedLocation: 19,
	InactiveConcept: 30,
	InactiveRegistered: 31,
	InactiveEnrouteHandedToCarrier: 32,
	InactiveEnrouteSorting: 33,
	InactiveEnrouteDistribution: 34,
	InactiveEnrouteCustoms: 35,
	InactiveDeliveredAtRecipient: 36,
	InactiveDeliveredReadyForPickup: 37,
	InactiveDeliveredPackagePickedUp: 38,
	CreditRejected: 100,
	CreditApproved: 101
};
L.PendingConcept, L.PendingRegistered, L.EnrouteHandedToCarrier, L.EnrouteSorting, L.EnrouteDistribution, L.DeliveredAtCustoms, L.DeliveredAtRecipient, L.DeliveredPackagePickedUp, L.DeliveredReturnShipmentPackagePickedUp, L.DeliveredAtAgreedLocation, L.PrintedLetter, L.PrintedDigitalStamp, L.InactiveConcept, L.InactiveRegistered, L.InactiveEnrouteHandedToCarrier, L.InactiveEnrouteSorting, L.InactiveEnrouteDistribution, L.InactiveEnrouteCustoms, L.InactiveDeliveredAtRecipient, L.InactiveDeliveredReadyForPickup, L.InactiveDeliveredPackagePickedUp;
//#endregion
//#region src/utils/adjustedDelivery.ts
var Ar = [
	x.EVENING_DELIVERY,
	x.EARLY_MORNING_DELIVERY,
	x.MORNING_DELIVERY,
	x.STANDARD_DELIVERY
], jr = {
	[E.EarlyMorning]: x.EARLY_MORNING_DELIVERY,
	[E.Morning]: x.MORNING_DELIVERY,
	[E.Standard]: x.STANDARD_DELIVERY,
	[E.Evening]: x.EVENING_DELIVERY,
	[E.SameDayDelivery]: x.SAME_DAY_DELIVERY,
	[E.Express]: x.EXPRESS_DELIVERY,
	[E.Pickup]: x.PICKUP_DELIVERY,
	[E.PickupExpress]: x.PICKUP_EXPRESS_DELIVERY
}, Mr = {
	[x.EARLY_MORNING_DELIVERY]: E.EarlyMorning,
	[x.MORNING_DELIVERY]: E.Morning,
	[x.STANDARD_DELIVERY]: E.Standard,
	[x.EVENING_DELIVERY]: E.Evening,
	[x.SAME_DAY_DELIVERY]: E.SameDayDelivery,
	[x.EXPRESS_DELIVERY]: E.Express,
	[x.PICKUP_DELIVERY]: E.Pickup,
	[x.PICKUP_EXPRESS_DELIVERY]: E.PickupExpress
}, Nr = (e) => Mr[e], Pr = (e) => jr[e], Fr = [x.PICKUP_DELIVERY, x.PICKUP_EXPRESS_DELIVERY], Ir = (e) => Ar.includes(e), Lr = (e) => Fr.includes(e), Rr = (e) => e?.micros ?? 0, zr = (e, t = "EUR") => ({
	currency: t,
	micros: e
}), Br = Object.create, Vr = Object.defineProperty, Hr = Object.getOwnPropertyDescriptor, Ur = Object.getOwnPropertyNames, Wr = Object.getPrototypeOf, Gr = Object.prototype.hasOwnProperty, Kr = (e, t) => () => (t || (e((t = { exports: {} }).exports, t), e = null), t.exports), qr = (e, t, n, r) => {
	if (t && typeof t == "object" || typeof t == "function") for (var i = Ur(t), a = 0, o = i.length, s; a < o; a++) s = i[a], !Gr.call(e, s) && s !== n && Vr(e, s, {
		get: ((e) => t[e]).bind(null, s),
		enumerable: !(r = Hr(t, s)) || r.enumerable
	});
	return e;
}, Jr = (e, t, n) => (n = e == null ? {} : Br(Wr(e)), qr(t || !e || !e.__esModule ? Vr(n, "default", {
	value: e,
	enumerable: !0
}) : n, e)), R = {
	PostNl: 1,
	Bpost: 2,
	CheapCargo: 3,
	Dpd: 4,
	Instabox: 5,
	Dhl: 6,
	Bol: 7,
	Ups: 8,
	DhlForYou: 9,
	DhlParcelConnect: 10,
	DhlEuroPlus: 11,
	UpsStandard: 12,
	UpsExpressSaver: 13,
	Gls: 14,
	Brt: 15,
	Trunkrs: 16,
	InPost: 17,
	PosteItaliane: 18,
	Spring: 19,
	ViaTim: 20
}, z = {
	PostNl: "postnl",
	POSTNL: "POSTNL",
	Bpost: "bpost",
	BPOST: "BPOST",
	CheapCargo: "cheapcargo",
	CHEAP_CARGO: "CHEAP_CARGO",
	Dpd: "dpd",
	DPD: "DPD",
	Instabox: "instabox",
	INSTABOX: "INSTABOX",
	Dhl: "dhl",
	BolCom: "bol.com",
	Bol: "bol",
	BOL: "BOL",
	Ups: "ups",
	UPS: "ups",
	DHL: "DHL",
	DhlForYou: "dhlforyou",
	DHL_FOR_YOU: "DHL_FOR_YOU",
	DhlParcelConnect: "dhlparcelconnect",
	DHL_PARCEL_CONNECT: "DHL_PARCEL_CONNECT",
	DhlEuroPlus: "dhleuroplus",
	DHL_EUROPLUS: "DHL_EUROPLUS",
	UpsStandard: "upsstandard",
	UPS_STANDARD: "UPS_STANDARD",
	UpsExpressSaver: "upsexpresssaver",
	UPS_EXPRESS_SAVER: "UPS_EXPRESS_SAVER",
	Gls: "gls",
	GLS: "GLS",
	Brt: "brt",
	BRT: "BRT",
	Trunkrs: "trunkrs",
	TRUNKRS: "TRUNKRS",
	InPost: "inpost",
	INPOST: "INPOST",
	PosteItaliane: "posteitaliane",
	POSTE_ITALIANE: "POSTE_ITALIANE",
	Spring: "spring",
	SPRING: "SPRING",
	ViaTim: "viatim",
	VIA_TIM: "VIA_TIM"
};
R.Dhl, R.Instabox, R.PostNl, z.PostNl, R.Bpost, z.Bpost, R.CheapCargo, z.CheapCargo, R.Dpd, z.Dpd, R.Instabox, z.Instabox, R.Dhl, z.Dhl, R.Bol, z.Bol, R.Ups, z.Ups, R.DhlForYou, z.DhlForYou, R.DhlParcelConnect, z.DhlParcelConnect, R.DhlEuroPlus, z.DhlEuroPlus, R.UpsStandard, z.UpsStandard, R.UpsExpressSaver, z.UpsExpressSaver, R.Gls, z.Gls, R.Brt, z.Brt, R.Trunkrs, z.Trunkrs, R.InPost, z.InPost, R.PosteItaliane, z.PosteItaliane, R.Spring, z.Spring, R.ViaTim, z.ViaTim, R.PostNl, z.POSTNL, R.Bpost, z.BPOST, R.CheapCargo, z.CHEAP_CARGO, R.Dpd, z.DPD, R.Instabox, z.INSTABOX, R.Dhl, z.DHL, R.Bol, z.BOL, R.Ups, z.UPS, R.DhlForYou, z.DHL_FOR_YOU, R.DhlParcelConnect, z.DHL_PARCEL_CONNECT, R.DhlEuroPlus, z.DHL_EUROPLUS, R.UpsStandard, z.UPS_STANDARD, R.UpsExpressSaver, z.UPS_EXPRESS_SAVER, R.Gls, z.GLS, R.Brt, z.BRT, R.Trunkrs, z.TRUNKRS, R.InPost, z.INPOST, R.PosteItaliane, z.POSTE_ITALIANE, R.Spring, z.SPRING, R.ViaTim, z.VIA_TIM, z.PostNl, R.PostNl, z.POSTNL, R.PostNl, z.Bpost, R.Bpost, z.BPOST, R.Bpost, z.CheapCargo, R.CheapCargo, z.CHEAP_CARGO, R.CheapCargo, z.Dpd, R.Dpd, z.DPD, R.Dpd, z.Instabox, R.Instabox, z.Dhl, R.Dhl, z.BolCom, R.Bol, z.Bol, R.Bol, z.BOL, R.Bol, z.Ups, R.Ups, z.DhlForYou, R.DhlForYou, z.DHL_FOR_YOU, R.DhlForYou, z.DhlParcelConnect, R.DhlParcelConnect, z.DHL_PARCEL_CONNECT, R.DhlParcelConnect, z.DhlEuroPlus, R.DhlEuroPlus, z.DHL_EUROPLUS, R.DhlEuroPlus, z.UpsStandard, R.UpsStandard, z.UPS_STANDARD, R.UpsStandard, z.UpsExpressSaver, R.UpsExpressSaver, z.UPS_EXPRESS_SAVER, R.UpsExpressSaver, z.Gls, R.Gls, z.GLS, R.Gls, z.Brt, R.Brt, z.BRT, R.Brt, z.Trunkrs, R.Trunkrs, z.TRUNKRS, R.Trunkrs, z.InPost, R.InPost, z.INPOST, R.InPost, z.PosteItaliane, R.PosteItaliane, z.POSTE_ITALIANE, R.PosteItaliane, z.Spring, R.Spring, z.SPRING, R.Spring, z.ViaTim, R.ViaTim, z.VIA_TIM, R.ViaTim, R.PostNl, R.Bpost, R.CheapCargo, R.Dpd, R.Instabox, R.Dhl, R.Bol, R.Ups, R.DhlForYou, R.DhlParcelConnect, R.DhlEuroPlus, R.UpsStandard, R.UpsExpressSaver, R.Gls, R.Brt, R.Trunkrs, R.InPost, R.PosteItaliane, R.ViaTim;
var B = {
	Afghanistan: "AF",
	AlandIslands: "AX",
	Albania: "AL",
	Algeria: "DZ",
	AmericanSamoa: "AS",
	AmericanVirginIslands: "VI",
	Andorra: "AD",
	Angola: "AO",
	Anguilla: "AI",
	Antarctica: "AQ",
	AntiguaAndBarbuda: "AG",
	Argentina: "AR",
	Armenia: "AM",
	Aruba: "AW",
	Australia: "AU",
	Austria: "AT",
	Azerbaijan: "AZ",
	Bahamas: "BS",
	Bahrain: "BH",
	Bangladesh: "BD",
	Barbados: "BB",
	Belarus: "BY",
	Belgium: "BE",
	Belize: "BZ",
	Benin: "BJ",
	Bermuda: "BM",
	Bhutan: "BT",
	Bolivia: "BO",
	BonaireSintEustatiusAndSaba: "BQ",
	BosniaAndHerzegovina: "BA",
	Botswana: "BW",
	BouvetIsland: "BV",
	Brazil: "BR",
	BritishIndianOceanTerritory: "IO",
	BritishVirginIslands: "VG",
	BruneiDarussalam: "BN",
	Bulgaria: "BG",
	BurkinaFaso: "BF",
	Burundi: "BI",
	CaboVerde: "CV",
	Cambodia: "KH",
	Cameroon: "CM",
	Canada: "CA",
	CanaryIslands: "IC",
	CaymanIslands: "KY",
	CentralAfricanRepublic: "CF",
	Chad: "TD",
	Chile: "CL",
	China: "CN",
	ChristmasIsland: "CX",
	CocosIslands: "CC",
	Colombia: "CO",
	Comoros: "KM",
	CongoBrazzaville: "CG",
	CongoKinshasa: "CD",
	CookIslands: "CK",
	CostaRica: "CR",
	CoteDIvoire: "CI",
	Croatia: "HR",
	Cuba: "CU",
	Curacao: "CW",
	Cyprus: "CY",
	CzechRepublic: "CZ",
	Denmark: "DK",
	Djibouti: "DJ",
	Dominica: "DM",
	DominicanRepublic: "DO",
	DutchAntilles: "AN",
	Ecuador: "EC",
	Egypt: "EG",
	ElSalvador: "SV",
	EquatorialGuinea: "GQ",
	Eritrea: "ER",
	Estonia: "EE",
	Eswatini: "SZ",
	Ethiopia: "ET",
	FalklandIslands: "FK",
	FaroeIslands: "FO",
	Fiji: "FJ",
	Finland: "FI",
	France: "FR",
	FrenchGuiana: "GF",
	FrenchPolynesia: "PF",
	FrenchSouthernTerritories: "TF",
	Gabon: "GA",
	Gambia: "GM",
	Georgia: "GE",
	Germany: "DE",
	Ghana: "GH",
	Gibraltar: "GI",
	Greece: "GR",
	Greenland: "GL",
	Grenada: "GD",
	Guadeloupe: "GP",
	Guam: "GU",
	Guatemala: "GT",
	Guernsey: "GG",
	Guinea: "GN",
	GuineaBissau: "GW",
	Guyana: "GY",
	Haiti: "HT",
	HeardIslandAndMcdonaldIslands: "HM",
	HolySee: "VA",
	Honduras: "HN",
	HongKong: "HK",
	Hungary: "HU",
	Iceland: "IS",
	India: "IN",
	Indonesia: "ID",
	Iran: "IR",
	Iraq: "IQ",
	Ireland: "IE",
	IsleOfMan: "IM",
	Israel: "IL",
	Italy: "IT",
	Jamaica: "JM",
	Japan: "JP",
	Jersey: "JE",
	Jordan: "JO",
	Kazakhstan: "KZ",
	Kenya: "KE",
	Kiribati: "KI",
	KoreaPeoplesDemocraticRepublic: "KP",
	KoreaRepublic: "KR",
	Kosovo: "XK",
	Kuwait: "KW",
	Kyrgyzstan: "KG",
	Laos: "LA",
	Latvia: "LV",
	Lebanon: "LB",
	Lesotho: "LS",
	Liberia: "LR",
	Libya: "LY",
	Liechtenstein: "LI",
	Lithuania: "LT",
	Luxembourg: "LU",
	Macao: "MO",
	Madagascar: "MG",
	Malawi: "MW",
	Malaysia: "MY",
	Maldives: "MV",
	Mali: "ML",
	Malta: "MT",
	MarshallIslands: "MH",
	Martinique: "MQ",
	Mauritania: "MR",
	Mauritius: "MU",
	Mayotte: "YT",
	Mexico: "MX",
	Micronesia: "FM",
	Moldova: "MD",
	Monaco: "MC",
	Mongolia: "MN",
	Montenegro: "ME",
	Montserrat: "MS",
	Morocco: "MA",
	Mozambique: "MZ",
	Myanmar: "MM",
	Namibia: "NA",
	Nauru: "NR",
	Nepal: "NP",
	Netherlands: "NL",
	NewCaledonia: "NC",
	NewZealand: "NZ",
	Nicaragua: "NI",
	Niger: "NE",
	Nigeria: "NG",
	Niue: "NU",
	NorfolkIsland: "NF",
	NorthMacedonia: "MK",
	NorthernMarianaIslands: "MP",
	Norway: "NO",
	Oman: "OM",
	Pakistan: "PK",
	Palau: "PW",
	Palestine: "PS",
	Panama: "PA",
	PapuaNewGuinea: "PG",
	Paraguay: "PY",
	Peru: "PE",
	Philippines: "PH",
	Pitcairn: "PN",
	Poland: "PL",
	Portugal: "PT",
	PuertoRico: "PR",
	Qatar: "QA",
	Reunion: "RE",
	Romania: "RO",
	RussianFederation: "RU",
	Rwanda: "RW",
	SaintBarthelemy: "BL",
	SaintHelena: "SH",
	SaintKittsAndNevis: "KN",
	SaintLucia: "LC",
	SaintMartin: "MF",
	SaintPierreAndMiquelon: "PM",
	SaintVincentAndTheGrenadines: "VC",
	Samoa: "WS",
	SanMarino: "SM",
	SaoTomeAndPrincipe: "ST",
	SaudiArabia: "SA",
	Senegal: "SN",
	Serbia: "RS",
	Seychelles: "SC",
	SierraLeone: "SL",
	Singapore: "SG",
	SintMaarten: "SX",
	Slovakia: "SK",
	Slovenia: "SI",
	SolomonIslands: "SB",
	Somalia: "SO",
	SouthAfrica: "ZA",
	SouthGeorgiaAndTheSouthSandwichIslands: "GS",
	SouthSudan: "SS",
	Spain: "ES",
	SriLanka: "LK",
	Sudan: "SD",
	Suriname: "SR",
	SvalbardAndJanMayen: "SJ",
	Sweden: "SE",
	Switzerland: "CH",
	SyrianArabRepublic: "SY",
	Taiwan: "TW",
	Tajikistan: "TJ",
	Tanzania: "TZ",
	Thailand: "TH",
	TimorLeste: "TL",
	Togo: "TG",
	Tokelau: "TK",
	Tonga: "TO",
	TrinidadAndTobago: "TT",
	Tunisia: "TN",
	Turkey: "TR",
	Turkmenistan: "TM",
	TurksAndCaicosIslands: "TC",
	Tuvalu: "TV",
	Uganda: "UG",
	Ukraine: "UA",
	UnitedArabEmirates: "AE",
	UnitedKingdom: "GB",
	UnitedStatesMinorOutlyingIslands: "UM",
	UnitedStatesOfAmerica: "US",
	Uruguay: "UY",
	Uzbekistan: "UZ",
	Vanuatu: "VU",
	Venezuela: "VE",
	Vietnam: "VN",
	WallisAndFutuna: "WF",
	WesternSahara: "EH",
	Yemen: "YE",
	Zambia: "ZM",
	Zimbabwe: "ZW"
};
B.Austria, B.Belgium, B.Bulgaria, B.Croatia, B.Cyprus, B.CzechRepublic, B.Denmark, B.Estonia, B.Finland, B.France, B.Germany, B.Greece, B.Hungary, B.Ireland, B.Italy, B.Latvia, B.Lithuania, B.Luxembourg, B.Malta, B.Netherlands, B.Poland, B.Portugal, B.Romania, B.Slovakia, B.Slovenia, B.Spain, B.Sweden, Object.values(B), B.Angola, B.AntiguaAndBarbuda, B.Aruba, B.Bahamas, B.Belize, B.Benin, B.Bermuda, B.BonaireSintEustatiusAndSaba, B.Botswana, B.BurkinaFaso, B.Burundi, B.Cameroon, B.CanaryIslands, B.CentralAfricanRepublic, B.Comoros, B.CongoBrazzaville, B.CongoKinshasa, B.CoteDIvoire, B.Curacao, B.Djibouti, B.Dominica, B.DutchAntilles, B.EquatorialGuinea, B.Eritrea, B.Fiji, B.Gabon, B.Gambia, B.Ghana, B.Grenada, B.Guyana, B.HongKong, B.Kiribati, B.KoreaPeoplesDemocraticRepublic, B.Macao, B.Malawi, B.Mali, B.Mauritania, B.Nauru, B.Qatar, B.Rwanda, B.SaintKittsAndNevis, B.SaoTomeAndPrincipe, B.Seychelles, B.SierraLeone, B.SintMaarten, B.Suriname, B.SyrianArabRepublic, B.TimorLeste, B.Togo, B.Tonga, B.Tuvalu, B.Uganda, B.UnitedArabEmirates, B.Vanuatu, B.Yemen, B.Zimbabwe, B.Austria, B.Belgium, B.Bulgaria, B.Croatia, B.CzechRepublic, B.Estonia, B.Finland, B.France, B.Germany, B.Greece, B.Hungary, B.Ireland, B.Italy, B.Latvia, B.Lithuania, B.Luxembourg, B.Malta, B.Netherlands, B.Portugal, B.Romania, B.Slovakia, B.Slovenia, B.Spain, B.UnitedKingdom, B.Denmark, B.Germany, B.Sweden;
var V = {
	EarlyMorning: 8,
	Morning: 1,
	Standard: 2,
	Evening: 3,
	Pickup: 4,
	PickupExpress: 5,
	SameDayDelivery: 6,
	Express: 7
}, H = {
	EarlyMorning: "early_morning",
	Morning: "morning",
	Standard: "standard",
	Evening: "evening",
	Pickup: "pickup",
	PickupExpress: "pickup_express",
	SameDayDelivery: "same_day",
	Express: "express"
}, U = {
	EarlyMorning: "EARLY_MORNING_DELIVERY",
	Morning: "MORNING_DELIVERY",
	Standard: "STANDARD_DELIVERY",
	Evening: "EVENING_DELIVERY",
	Pickup: "PICKUP_DELIVERY",
	PickupExpress: "PICKUP_EXPRESS_DELIVERY",
	SameDayDelivery: "SAME_DAY_DELIVERY",
	Express: "EXPRESS_DELIVERY"
};
V.EarlyMorning, H.EarlyMorning, V.Morning, H.Morning, V.Standard, H.Standard, V.Evening, H.Evening, V.Pickup, H.Pickup, V.PickupExpress, H.PickupExpress, V.SameDayDelivery, H.SameDayDelivery, V.Express, H.Express, H.EarlyMorning, V.EarlyMorning, H.Morning, V.Morning, H.Standard, V.Standard, H.Evening, V.Evening, H.Pickup, V.Pickup, H.PickupExpress, V.PickupExpress, H.SameDayDelivery, V.SameDayDelivery, H.Express, V.Express, V.EarlyMorning, U.EarlyMorning, V.Morning, U.Morning, V.Standard, U.Standard, V.Evening, U.Evening, V.Pickup, U.Pickup, V.PickupExpress, U.PickupExpress, V.SameDayDelivery, U.SameDayDelivery, V.Express, U.Express, U.EarlyMorning, H.EarlyMorning, U.Morning, H.Morning, U.Standard, H.Standard, U.Evening, H.Evening, U.Pickup, H.Pickup, U.PickupExpress, H.PickupExpress, U.SameDayDelivery, H.SameDayDelivery, U.Express, H.Express, V.EarlyMorning, V.Morning, V.Standard, V.Evening, V.Pickup, V.PickupExpress, V.SameDayDelivery, V.Express, { Vasco: 1 }.Vasco, { Vasco: "vasco" }.Vasco;
var W = {
	Sunday: 0,
	Monday: 1,
	Tuesday: 2,
	Wednesday: 3,
	Thursday: 4,
	Friday: 5,
	Saturday: 6
}, G = {
	Sunday: "sunday",
	Monday: "monday",
	Tuesday: "tuesday",
	Wednesday: "wednesday",
	Thursday: "thursday",
	Friday: "friday",
	Saturday: "saturday"
};
G.Sunday, W.Sunday, G.Monday, W.Monday, G.Tuesday, W.Tuesday, G.Wednesday, W.Wednesday, G.Thursday, W.Thursday, G.Friday, W.Friday, G.Saturday, W.Saturday, W.Sunday, G.Sunday, W.Monday, G.Monday, W.Tuesday, G.Tuesday, W.Wednesday, G.Wednesday, W.Thursday, G.Thursday, W.Friday, G.Friday, W.Saturday, G.Saturday;
var Yr = {
	Bytes: "B",
	Kilobytes: "KB",
	Megabytes: "MB",
	Gigabytes: "GB",
	Terabytes: "TB"
};
Yr.Bytes, Yr.Kilobytes, Yr.Megabytes, Yr.Gigabytes, Yr.Terabytes;
var Xr = {
	Bol: 1,
	Exact: 2,
	Amazon: 6,
	Wix: 8,
	ExactDe: 10,
	Etsy: 11
}, Zr = {
	Bol: "bol_dot_com",
	Wix: "wix",
	Exact: "exact",
	ExactDe: "exact_de",
	Amazon: "amazon",
	Etsy: "etsy"
};
Xr.Bol, Zr.Bol, Xr.Exact, Zr.Exact, Xr.Amazon, Zr.Amazon, Xr.Wix, Zr.Wix, Xr.ExactDe, Zr.ExactDe, Xr.Etsy, Zr.Etsy, Zr.Bol, Xr.Bol, Zr.Exact, Xr.Exact, Zr.Amazon, Xr.Amazon, Zr.Wix, Xr.Wix, Zr.ExactDe, Xr.ExactDe, Zr.Etsy, Xr.Etsy;
var K = {
	Unpaid: 1,
	Due: 101,
	DuePrepayment: 102,
	Reminder1: 106,
	Reminder2: 111,
	Dun: 116,
	Collection: 121,
	Instalments: 126,
	PaymentArrangement: 127,
	Dispute: 128,
	LegalProcedure: 129,
	Insolvency: 130,
	WriteOff: 131,
	Pending: 301,
	Cancelled: 401,
	Paid: 501,
	PaidOnline: 506,
	PaidAutomatic: 511,
	PaidCredit: 597,
	PaidZeroItems: 598,
	InvoiceWith0InvoiceItemsPaidZeroBalance: 599
}, q = {
	Unpaid: "Unpaid",
	Due: "Due",
	DuePrepayment: "DuePrepayment",
	Reminder1: "Reminder1",
	Reminder2: "Reminder2",
	Dun: "Dun",
	Collection: "Collection",
	Instalments: "Instalments",
	PaymentArrangement: "PaymentArrangement",
	Dispute: "Dispute",
	LegalProcedure: "LegalProcedure",
	Insolvency: "Insolvency",
	WriteOff: "WriteOff",
	Pending: "Pending",
	Cancelled: "Cancelled",
	Paid: "Paid",
	PaidOnline: "PaidOnline",
	PaidAutomatic: "PaidAutomatic",
	PaidCredit: "PaidCredit",
	PaidZeroItems: "PaidZeroItems",
	PaidZeroBalance: "PaidZeroBalance"
};
K.Unpaid, q.Unpaid, K.Due, q.Due, K.DuePrepayment, q.DuePrepayment, K.Reminder1, q.Reminder1, K.Reminder2, q.Reminder2, K.Dun, q.Dun, K.Collection, q.Collection, K.Instalments, q.Instalments, K.PaymentArrangement, q.PaymentArrangement, K.Dispute, q.Dispute, K.LegalProcedure, q.LegalProcedure, K.Insolvency, q.Insolvency, K.WriteOff, q.WriteOff, K.Pending, q.Pending, K.Cancelled, q.Cancelled, K.Paid, q.Paid, K.PaidOnline, q.PaidOnline, K.PaidAutomatic, q.PaidAutomatic, K.PaidCredit, q.PaidCredit, K.PaidZeroItems, q.PaidZeroItems, K.InvoiceWith0InvoiceItemsPaidZeroBalance, q.PaidZeroBalance, K.Due, K.Reminder1, K.Reminder2, K.Dun, K.Collection, K.Instalments, K.PaymentArrangement, K.Dispute, K.Paid, K.PaidOnline, K.PaidAutomatic, K.PaidCredit, K.PaidZeroItems;
var Qr = {
	Gram: "gram",
	Kilogram: "kilogram"
}, $r = {
	Gram: "g",
	Kilogram: "kg"
}, ei = {
	[$r.Gram]: 1,
	[$r.Kilogram]: 1e3
}, ti = {
	Millimeter: "mm",
	Centimeter: "cm",
	Meter: "m"
};
ti.Millimeter, ti.Centimeter, ti.Meter;
var ni = {
	Eu: "EU",
	HomeCountry: "Home Country",
	Row: "ROW",
	Cd: "CD",
	World: "WERELD"
}, ri = {
	PendingConcept: 1,
	PendingRegistered: 2,
	EnRouteHandedToCarrier: 3,
	EnRouteSorting: 4,
	EnRouteDistribution: 5,
	EnRouteCustoms: 6,
	DeliveredAtRecipient: 7,
	DeliveredReadyForPickup: 8,
	DeliveredPackagePickedUp: 9,
	DeliveredReturnShipmentReadyForPickup: 10,
	DeliveredReturnShipmentPackagePickedUp: 11,
	PrintedLetter: 12,
	InactiveCredited: 13,
	PrintedDigitalStamp: 14,
	Expired: 16,
	Cancelled: 17,
	InactiveConcept: 30,
	InactiveRegistered: 31,
	InactiveEnRouteHandedToCarrier: 32,
	InactiveEnRouteSorting: 33,
	InactiveEnRouteDistribution: 34,
	InactiveEnRouteCustoms: 35,
	InactiveDeliveredAtRecipient: 36,
	InactiveDeliveredReadyForPickup: 37,
	InactiveDeliveredPackagePickedUp: 38
};
ri.PendingConcept, ri.PendingRegistered, ri.EnRouteHandedToCarrier, ri.EnRouteSorting, ri.EnRouteDistribution, ri.EnRouteCustoms, ri.DeliveredReadyForPickup, ri.DeliveredAtRecipient, ri.DeliveredPackagePickedUp;
var J = {
	Light: "light",
	Start: "start",
	Plus: "plus",
	Premium: "premium",
	Max: "max"
}, ii = {
	Light: 0,
	Start: 1,
	Plus: 2,
	Premium: 3,
	Max: 4
};
ii.Light, J.Light, ii.Start, J.Start, ii.Plus, J.Plus, ii.Premium, J.Premium, ii.Max, J.Max, J.Light, ii.Light, J.Start, ii.Start, J.Plus, ii.Plus, J.Premium, ii.Premium, J.Max, ii.Max;
var ai = {
	Start: 4800,
	Plus: 4801,
	Premium: 4802,
	Max: 4803
}, oi = {
	Start: J.Start,
	Plus: J.Plus,
	Premium: J.Premium,
	Max: J.Max
};
ai.Start, oi.Start, ai.Plus, oi.Plus, ai.Premium, oi.Premium, ai.Max, oi.Max, oi.Start, ai.Start, oi.Plus, ai.Plus, oi.Premium, ai.Premium, oi.Max, ai.Max;
var si = {
	Start: 4700,
	Plus: 4701,
	Premium: 4702,
	Max: 4703
}, ci = {
	Start: J.Start,
	Plus: J.Plus,
	Premium: J.Premium,
	Max: J.Max
};
si.Start, ci.Start, si.Plus, ci.Plus, si.Premium, ci.Premium, si.Max, ci.Max, ci.Start, si.Start, ci.Plus, si.Plus, ci.Premium, si.Premium, ci.Max, si.Max;
var li = {
	Light: 4610,
	Start: 4611,
	Plus: 4612,
	Premium: 4613,
	Max: 4614
}, ui = {
	Light: J.Light,
	Start: J.Start,
	Plus: J.Plus,
	Premium: J.Premium,
	Max: J.Max
};
li.Light, ui.Light, li.Start, ui.Start, li.Plus, ui.Plus, li.Premium, ui.Premium, li.Max, ui.Max, ui.Light, li.Light, ui.Start, li.Start, ui.Plus, li.Plus, ui.Premium, li.Premium, ui.Max, li.Max;
var di = {
	Start: 4615,
	Plus: 4616,
	Premium: 4617,
	Max: 4618
}, fi = {
	Start: J.Start,
	Plus: J.Plus,
	Premium: J.Premium,
	Max: J.Max
};
di.Start, fi.Start, di.Plus, fi.Plus, di.Premium, fi.Premium, di.Max, fi.Max, fi.Start, di.Start, fi.Plus, di.Plus, fi.Premium, di.Premium, fi.Max, di.Max;
var Y = {
	MyParcel: 1,
	Flespakket: 2,
	SendMyParcel: 3,
	DeliverDutch: 4,
	PostNlPlugin: 5,
	MyParcelIt: 6
}, pi = {
	MyParcel: "myparcel",
	Flespakket: "flespakket",
	SendMyParcel: "belgie",
	DeliverDutch: "deliver-dutch",
	PostNlPlugin: "postnl-plugin",
	MyParcelIt: "italie"
}, X = {
	Default: "default",
	MyParcelNl: "myparcel-nederland",
	MyParcelBe: "myparcel-belgie",
	MyParcelIt: "myparcel-italie",
	DeliverDutch: "deliver-dutch",
	PostNlPlugin: "postnl-plugin"
};
Y.MyParcel, pi.MyParcel, Y.Flespakket, pi.Flespakket, Y.SendMyParcel, pi.SendMyParcel, Y.MyParcelIt, pi.MyParcelIt, Y.DeliverDutch, pi.DeliverDutch, Y.PostNlPlugin, pi.PostNlPlugin, Y.MyParcel, X.MyParcelNl, Y.Flespakket, X.MyParcelNl, Y.SendMyParcel, X.MyParcelBe, Y.MyParcelIt, X.MyParcelIt, Y.DeliverDutch, X.DeliverDutch, Y.PostNlPlugin, X.PostNlPlugin, X.MyParcelNl, Y.MyParcel, X.MyParcelBe, Y.SendMyParcel, X.MyParcelIt, Y.MyParcelIt, X.MyParcelNl, ni.HomeCountry, B.Netherlands, ni.Eu, ni.Row, B.Belgium, X.MyParcelBe, ni.HomeCountry, B.Belgium, B.Netherlands, ni.Eu, ni.Row, X.MyParcelBe, ni.HomeCountry, B.Belgium, ni.Eu, ni.Row, X.MyParcelNl, ni.HomeCountry, B.Netherlands, ni.Eu, ni.Row, X.MyParcelNl, ni.HomeCountry, B.Netherlands, B.Belgium, B.Luxembourg, R.Bpost, R.PostNl, R.DhlForYou, R.DhlParcelConnect, R.DhlEuroPlus, R.Ups, R.UpsStandard, R.UpsExpressSaver;
var Z = {
	Package: 1,
	Mailbox: 2,
	Letter: 3,
	DigitalStamp: 4,
	Pallet: 5,
	PackageSmall: 6,
	Envelope: 7
}, Q = {
	Package: "package",
	Mailbox: "mailbox",
	Letter: "letter",
	DigitalStamp: "digital_stamp",
	Pallet: "pallet",
	PackageSmall: "package_small",
	Envelope: "envelope"
};
Z.Package, Q.Package, Z.Mailbox, Q.Mailbox, Z.Letter, Q.Letter, Z.DigitalStamp, Q.DigitalStamp, Z.Pallet, Q.Pallet, Z.PackageSmall, Q.PackageSmall, Z.Envelope, Q.Envelope, Q.Package, Z.Package, Q.Mailbox, Z.Mailbox, Q.Letter, Z.Letter, Q.DigitalStamp, Z.DigitalStamp, Q.Pallet, Z.Pallet, Q.PackageSmall, Z.PackageSmall, Q.Envelope, Z.Envelope;
var mi = {
	DIGITAL_STAMP: "DIGITAL_STAMP",
	ENVELOPE: "ENVELOPE",
	MAILBOX: "MAILBOX",
	PACKAGE: "PACKAGE",
	PALLET: "PALLET",
	SMALL_PACKAGE: "SMALL_PACKAGE",
	UNFRANKED: "UNFRANKED"
};
Z.Package, mi.PACKAGE, Z.Mailbox, mi.MAILBOX, Z.Letter, mi.UNFRANKED, Z.DigitalStamp, mi.DIGITAL_STAMP, Z.Pallet, mi.PALLET, Z.PackageSmall, mi.SMALL_PACKAGE, Z.Envelope, mi.ENVELOPE, mi.PACKAGE, Z.Package, mi.MAILBOX, Z.Mailbox, mi.UNFRANKED, Z.Letter, mi.DIGITAL_STAMP, Z.DigitalStamp, mi.PALLET, Z.Pallet, mi.SMALL_PACKAGE, Z.PackageSmall, mi.ENVELOPE, Z.Envelope, Z.Package, Z.Mailbox, Z.Letter, Z.DigitalStamp, Z.Pallet, Z.PackageSmall, Z.Envelope;
var $ = {
	PendingConcept: 1,
	PendingRegistered: 2,
	EnrouteHandedToCarrier: 3,
	EnrouteSorting: 4,
	EnrouteDistribution: 5,
	DeliveredAtCustoms: 6,
	DeliveredAtRecipient: 7,
	DeliveredReadyForPickup: 8,
	DeliveredPackagePickedUp: 9,
	DeliveredReturnShipmentReadyForPickup: 10,
	DeliveredReturnShipmentPackagePickedUp: 11,
	PrintedUnpaidLabel: 12,
	PrintedLetter: 12,
	Credited: 13,
	PrintedStamp: 14,
	PrintedDigitalStamp: 14,
	Expired: 16,
	Cancelled: 17,
	PrintedUntrackedShipment: 18,
	DeliveredAtAgreedLocation: 19,
	InactiveConcept: 30,
	InactiveRegistered: 31,
	InactiveEnrouteHandedToCarrier: 32,
	InactiveEnrouteSorting: 33,
	InactiveEnrouteDistribution: 34,
	InactiveEnrouteCustoms: 35,
	InactiveDeliveredAtRecipient: 36,
	InactiveDeliveredReadyForPickup: 37,
	InactiveDeliveredPackagePickedUp: 38,
	CreditRejected: 100,
	CreditApproved: 101
};
$.PendingConcept, $.PendingRegistered, $.EnrouteHandedToCarrier, $.EnrouteSorting, $.EnrouteDistribution, $.DeliveredAtCustoms, $.DeliveredAtRecipient, $.DeliveredPackagePickedUp, $.DeliveredReturnShipmentPackagePickedUp, $.DeliveredAtAgreedLocation, $.PrintedLetter, $.PrintedDigitalStamp, $.InactiveConcept, $.InactiveRegistered, $.InactiveEnrouteHandedToCarrier, $.InactiveEnrouteSorting, $.InactiveEnrouteDistribution, $.InactiveEnrouteCustoms, $.InactiveDeliveredAtRecipient, $.InactiveDeliveredReadyForPickup, $.InactiveDeliveredPackagePickedUp;
var hi = /* @__PURE__ */ Kr(((e, t) => {
	(function(n, r) {
		typeof e == "object" && t !== void 0 ? t.exports = r() : typeof define == "function" && define.amd ? define(r) : (n = typeof globalThis < "u" ? globalThis : n || self).dayjs = r();
	})(e, (function() {
		var e = 1e3, t = 6e4, n = 36e5, r = "millisecond", i = "second", a = "minute", o = "hour", s = "day", c = "week", l = "month", u = "quarter", d = "year", f = "date", p = "Invalid Date", m = /^(\d{4})[-/]?(\d{1,2})?[-/]?(\d{0,2})[Tt\s]*(\d{1,2})?:?(\d{1,2})?:?(\d{1,2})?[.:]?(\d+)?$/, h = /\[([^\]]+)]|Y{1,4}|M{1,4}|D{1,2}|d{1,4}|H{1,2}|h{1,2}|a|A|m{1,2}|s{1,2}|Z{1,2}|SSS/g, ee = {
			name: "en",
			weekdays: "Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday".split("_"),
			months: "January_February_March_April_May_June_July_August_September_October_November_December".split("_"),
			ordinal: function(e) {
				var t = [
					"th",
					"st",
					"nd",
					"rd"
				], n = e % 100;
				return "[" + e + (t[(n - 20) % 10] || t[n] || t[0]) + "]";
			}
		}, g = function(e, t, n) {
			var r = String(e);
			return !r || r.length >= t ? e : "" + Array(t + 1 - r.length).join(n) + e;
		}, te = {
			s: g,
			z: function(e) {
				var t = -e.utcOffset(), n = Math.abs(t), r = Math.floor(n / 60), i = n % 60;
				return (t <= 0 ? "+" : "-") + g(r, 2, "0") + ":" + g(i, 2, "0");
			},
			m: function e(t, n) {
				if (t.date() < n.date()) return -e(n, t);
				var r = 12 * (n.year() - t.year()) + (n.month() - t.month()), i = t.clone().add(r, l), a = n - i < 0, o = t.clone().add(r + (a ? -1 : 1), l);
				return +(-(r + (n - i) / (a ? i - o : o - i)) || 0);
			},
			a: function(e) {
				return e < 0 ? Math.ceil(e) || 0 : Math.floor(e);
			},
			p: function(e) {
				return {
					M: l,
					y: d,
					w: c,
					d: s,
					D: f,
					h: o,
					m: a,
					s: i,
					ms: r,
					Q: u
				}[e] || String(e || "").toLowerCase().replace(/s$/, "");
			},
			u: function(e) {
				return e === void 0;
			}
		}, _ = "en", v = {};
		v[_] = ee;
		var ne = "$isDayjsObject", re = function(e) {
			return e instanceof ae || !(!e || !e[ne]);
		}, ie = function e(t, n, r) {
			var i;
			if (!t) return _;
			if (typeof t == "string") {
				var a = t.toLowerCase();
				v[a] && (i = a), n && (v[a] = n, i = a);
				var o = t.split("-");
				if (!i && o.length > 1) return e(o[0]);
			} else {
				var s = t.name;
				v[s] = t, i = s;
			}
			return !r && i && (_ = i), i || !r && _;
		}, y = function(e, t) {
			if (re(e)) return e.clone();
			var n = typeof t == "object" ? t : {};
			return n.date = e, n.args = arguments, new ae(n);
		}, b = te;
		b.l = ie, b.i = re, b.w = function(e, t) {
			return y(e, {
				locale: t.$L,
				utc: t.$u,
				x: t.$x,
				$offset: t.$offset
			});
		};
		var ae = function() {
			function ee(e) {
				this.$L = ie(e.locale, null, !0), this.parse(e), this.$x = this.$x || e.x || {}, this[ne] = !0;
			}
			var g = ee.prototype;
			return g.parse = function(e) {
				this.$d = function(e) {
					var t = e.date, n = e.utc;
					if (t === null) return /* @__PURE__ */ new Date(NaN);
					if (b.u(t)) return /* @__PURE__ */ new Date();
					if (t instanceof Date) return new Date(t);
					if (typeof t == "string" && !/Z$/i.test(t)) {
						var r = t.match(m);
						if (r) {
							var i = r[2] - 1 || 0, a = (r[7] || "0").substring(0, 3);
							return n ? new Date(Date.UTC(r[1], i, r[3] || 1, r[4] || 0, r[5] || 0, r[6] || 0, a)) : new Date(r[1], i, r[3] || 1, r[4] || 0, r[5] || 0, r[6] || 0, a);
						}
					}
					return new Date(t);
				}(e), this.init();
			}, g.init = function() {
				var e = this.$d;
				this.$y = e.getFullYear(), this.$M = e.getMonth(), this.$D = e.getDate(), this.$W = e.getDay(), this.$H = e.getHours(), this.$m = e.getMinutes(), this.$s = e.getSeconds(), this.$ms = e.getMilliseconds();
			}, g.$utils = function() {
				return b;
			}, g.isValid = function() {
				return this.$d.toString() !== p;
			}, g.isSame = function(e, t) {
				var n = y(e);
				return this.startOf(t) <= n && n <= this.endOf(t);
			}, g.isAfter = function(e, t) {
				return y(e) < this.startOf(t);
			}, g.isBefore = function(e, t) {
				return this.endOf(t) < y(e);
			}, g.$g = function(e, t, n) {
				return b.u(e) ? this[t] : this.set(n, e);
			}, g.unix = function() {
				return Math.floor(this.valueOf() / 1e3);
			}, g.valueOf = function() {
				return this.$d.getTime();
			}, g.startOf = function(e, t) {
				var n = this, r = !!b.u(t) || t, u = b.p(e), p = function(e, t) {
					var i = b.w(n.$u ? Date.UTC(n.$y, t, e) : new Date(n.$y, t, e), n);
					return r ? i : i.endOf(s);
				}, m = function(e, t) {
					return b.w(n.toDate()[e].apply(n.toDate("s"), (r ? [
						0,
						0,
						0,
						0
					] : [
						23,
						59,
						59,
						999
					]).slice(t)), n);
				}, h = this.$W, ee = this.$M, g = this.$D, te = "set" + (this.$u ? "UTC" : "");
				switch (u) {
					case d: return r ? p(1, 0) : p(31, 11);
					case l: return r ? p(1, ee) : p(0, ee + 1);
					case c:
						var _ = this.$locale().weekStart || 0, v = (h < _ ? h + 7 : h) - _;
						return p(r ? g - v : g + (6 - v), ee);
					case s:
					case f: return m(te + "Hours", 0);
					case o: return m(te + "Minutes", 1);
					case a: return m(te + "Seconds", 2);
					case i: return m(te + "Milliseconds", 3);
					default: return this.clone();
				}
			}, g.endOf = function(e) {
				return this.startOf(e, !1);
			}, g.$set = function(e, t) {
				var n, c = b.p(e), u = "set" + (this.$u ? "UTC" : ""), p = (n = {}, n[s] = u + "Date", n[f] = u + "Date", n[l] = u + "Month", n[d] = u + "FullYear", n[o] = u + "Hours", n[a] = u + "Minutes", n[i] = u + "Seconds", n[r] = u + "Milliseconds", n)[c], m = c === s ? this.$D + (t - this.$W) : t;
				if (c === l || c === d) {
					var h = this.clone().set(f, 1);
					h.$d[p](m), h.init(), this.$d = h.set(f, Math.min(this.$D, h.daysInMonth())).$d;
				} else p && this.$d[p](m);
				return this.init(), this;
			}, g.set = function(e, t) {
				return this.clone().$set(e, t);
			}, g.get = function(e) {
				return this[b.p(e)]();
			}, g.add = function(r, u) {
				var f, p = this;
				r = Number(r);
				var m = b.p(u), h = function(e) {
					var t = y(p);
					return b.w(t.date(t.date() + Math.round(e * r)), p);
				};
				if (m === l) return this.set(l, this.$M + r);
				if (m === d) return this.set(d, this.$y + r);
				if (m === s) return h(1);
				if (m === c) return h(7);
				var ee = (f = {}, f[a] = t, f[o] = n, f[i] = e, f)[m] || 1, g = this.$d.getTime() + r * ee;
				return b.w(g, this);
			}, g.subtract = function(e, t) {
				return this.add(-1 * e, t);
			}, g.format = function(e) {
				var t = this, n = this.$locale();
				if (!this.isValid()) return n.invalidDate || p;
				var r = e || "YYYY-MM-DDTHH:mm:ssZ", i = b.z(this), a = this.$H, o = this.$m, s = this.$M, c = n.weekdays, l = n.months, u = n.meridiem, d = function(e, n, i, a) {
					return e && (e[n] || e(t, r)) || i[n].slice(0, a);
				}, f = function(e) {
					return b.s(a % 12 || 12, e, "0");
				}, m = u || function(e, t, n) {
					var r = e < 12 ? "AM" : "PM";
					return n ? r.toLowerCase() : r;
				};
				return r.replace(h, (function(e, r) {
					return r || function(e) {
						switch (e) {
							case "YY": return String(t.$y).slice(-2);
							case "YYYY": return b.s(t.$y, 4, "0");
							case "M": return s + 1;
							case "MM": return b.s(s + 1, 2, "0");
							case "MMM": return d(n.monthsShort, s, l, 3);
							case "MMMM": return d(l, s);
							case "D": return t.$D;
							case "DD": return b.s(t.$D, 2, "0");
							case "d": return String(t.$W);
							case "dd": return d(n.weekdaysMin, t.$W, c, 2);
							case "ddd": return d(n.weekdaysShort, t.$W, c, 3);
							case "dddd": return c[t.$W];
							case "H": return String(a);
							case "HH": return b.s(a, 2, "0");
							case "h": return f(1);
							case "hh": return f(2);
							case "a": return m(a, o, !0);
							case "A": return m(a, o, !1);
							case "m": return String(o);
							case "mm": return b.s(o, 2, "0");
							case "s": return String(t.$s);
							case "ss": return b.s(t.$s, 2, "0");
							case "SSS": return b.s(t.$ms, 3, "0");
							case "Z": return i;
						}
						return null;
					}(e) || i.replace(":", "");
				}));
			}, g.utcOffset = function() {
				return 15 * -Math.round(this.$d.getTimezoneOffset() / 15);
			}, g.diff = function(r, f, p) {
				var m, h = this, ee = b.p(f), g = y(r), te = (g.utcOffset() - this.utcOffset()) * t, _ = this - g, v = function() {
					return b.m(h, g);
				};
				switch (ee) {
					case d:
						m = v() / 12;
						break;
					case l:
						m = v();
						break;
					case u:
						m = v() / 3;
						break;
					case c:
						m = (_ - te) / 6048e5;
						break;
					case s:
						m = (_ - te) / 864e5;
						break;
					case o:
						m = _ / n;
						break;
					case a:
						m = _ / t;
						break;
					case i:
						m = _ / e;
						break;
					default: m = _;
				}
				return p ? m : b.a(m);
			}, g.daysInMonth = function() {
				return this.endOf(l).$D;
			}, g.$locale = function() {
				return v[this.$L];
			}, g.locale = function(e, t) {
				if (!e) return this.$L;
				var n = this.clone(), r = ie(e, t, !0);
				return r && (n.$L = r), n;
			}, g.clone = function() {
				return b.w(this.$d, this);
			}, g.toDate = function() {
				return new Date(this.valueOf());
			}, g.toJSON = function() {
				return this.isValid() ? this.toISOString() : null;
			}, g.toISOString = function() {
				return this.$d.toISOString();
			}, g.toString = function() {
				return this.$d.toUTCString();
			}, ee;
		}(), oe = ae.prototype;
		return y.prototype = oe, [
			["$ms", r],
			["$s", i],
			["$m", a],
			["$H", o],
			["$W", s],
			["$M", l],
			["$y", d],
			["$D", f]
		].forEach((function(e) {
			oe[e[1]] = function(t) {
				return this.$g(t, e[0], e[1]);
			};
		})), y.extend = function(e, t) {
			return e.$i ||= (e(t, ae, y), !0), y;
		}, y.locale = ie, y.isDayjs = re, y.unix = function(e) {
			return y(1e3 * e);
		}, y.en = v[_], y.Ls = v, y.p = {}, y;
	}));
})), gi = /* @__PURE__ */ Kr(((e, t) => {
	(function(n, r) {
		typeof e == "object" && t !== void 0 ? t.exports = r(hi()) : typeof define == "function" && define.amd ? define(["dayjs"], r) : (n = typeof globalThis < "u" ? globalThis : n || self).dayjs_locale_nl = r(n.dayjs);
	})(e, (function(e) {
		function t(e) {
			return e && typeof e == "object" && "default" in e ? e : { default: e };
		}
		var n = t(e), r = {
			name: "nl",
			weekdays: "zondag_maandag_dinsdag_woensdag_donderdag_vrijdag_zaterdag".split("_"),
			weekdaysShort: "zo._ma._di._wo._do._vr._za.".split("_"),
			weekdaysMin: "zo_ma_di_wo_do_vr_za".split("_"),
			months: "januari_februari_maart_april_mei_juni_juli_augustus_september_oktober_november_december".split("_"),
			monthsShort: "jan_feb_mrt_apr_mei_jun_jul_aug_sep_okt_nov_dec".split("_"),
			ordinal: function(e) {
				return "[" + e + (e === 1 || e === 8 || e >= 20 ? "ste" : "de") + "]";
			},
			weekStart: 1,
			yearStart: 4,
			formats: {
				LT: "HH:mm",
				LTS: "HH:mm:ss",
				L: "DD-MM-YYYY",
				LL: "D MMMM YYYY",
				LLL: "D MMMM YYYY HH:mm",
				LLLL: "dddd D MMMM YYYY HH:mm"
			},
			relativeTime: {
				future: "over %s",
				past: "%s geleden",
				s: "een paar seconden",
				m: "een minuut",
				mm: "%d minuten",
				h: "een uur",
				hh: "%d uur",
				d: "een dag",
				dd: "%d dagen",
				M: "een maand",
				MM: "%d maanden",
				y: "een jaar",
				yy: "%d jaar"
			}
		};
		return n.default.locale(r, null, !0), r;
	}));
})), _i = /* @__PURE__ */ Kr(((e, t) => {
	(function(n, r) {
		typeof e == "object" && t !== void 0 ? t.exports = r(hi()) : typeof define == "function" && define.amd ? define(["dayjs"], r) : (n = typeof globalThis < "u" ? globalThis : n || self).dayjs_locale_it = r(n.dayjs);
	})(e, (function(e) {
		function t(e) {
			return e && typeof e == "object" && "default" in e ? e : { default: e };
		}
		var n = t(e), r = {
			name: "it",
			weekdays: "domenica_lunedì_martedì_mercoledì_giovedì_venerdì_sabato".split("_"),
			weekdaysShort: "dom_lun_mar_mer_gio_ven_sab".split("_"),
			weekdaysMin: "do_lu_ma_me_gi_ve_sa".split("_"),
			months: "gennaio_febbraio_marzo_aprile_maggio_giugno_luglio_agosto_settembre_ottobre_novembre_dicembre".split("_"),
			weekStart: 1,
			monthsShort: "gen_feb_mar_apr_mag_giu_lug_ago_set_ott_nov_dic".split("_"),
			formats: {
				LT: "HH:mm",
				LTS: "HH:mm:ss",
				L: "DD/MM/YYYY",
				LL: "D MMMM YYYY",
				LLL: "D MMMM YYYY HH:mm",
				LLLL: "dddd D MMMM YYYY HH:mm"
			},
			relativeTime: {
				future: "tra %s",
				past: "%s fa",
				s: "qualche secondo",
				m: "un minuto",
				mm: "%d minuti",
				h: "un' ora",
				hh: "%d ore",
				d: "un giorno",
				dd: "%d giorni",
				M: "un mese",
				MM: "%d mesi",
				y: "un anno",
				yy: "%d anni"
			},
			ordinal: function(e) {
				return e + "º";
			}
		};
		return n.default.locale(r, null, !0), r;
	}));
})), vi = /* @__PURE__ */ Kr(((e, t) => {
	(function(n, r) {
		typeof e == "object" && t !== void 0 ? t.exports = r(hi()) : typeof define == "function" && define.amd ? define(["dayjs"], r) : (n = typeof globalThis < "u" ? globalThis : n || self).dayjs_locale_fr = r(n.dayjs);
	})(e, (function(e) {
		function t(e) {
			return e && typeof e == "object" && "default" in e ? e : { default: e };
		}
		var n = t(e), r = {
			name: "fr",
			weekdays: "dimanche_lundi_mardi_mercredi_jeudi_vendredi_samedi".split("_"),
			weekdaysShort: "dim._lun._mar._mer._jeu._ven._sam.".split("_"),
			weekdaysMin: "di_lu_ma_me_je_ve_sa".split("_"),
			months: "janvier_février_mars_avril_mai_juin_juillet_août_septembre_octobre_novembre_décembre".split("_"),
			monthsShort: "janv._févr._mars_avr._mai_juin_juil._août_sept._oct._nov._déc.".split("_"),
			weekStart: 1,
			yearStart: 4,
			formats: {
				LT: "HH:mm",
				LTS: "HH:mm:ss",
				L: "DD/MM/YYYY",
				LL: "D MMMM YYYY",
				LLL: "D MMMM YYYY HH:mm",
				LLLL: "dddd D MMMM YYYY HH:mm"
			},
			relativeTime: {
				future: "dans %s",
				past: "il y a %s",
				s: "quelques secondes",
				m: "une minute",
				mm: "%d minutes",
				h: "une heure",
				hh: "%d heures",
				d: "un jour",
				dd: "%d jours",
				M: "un mois",
				MM: "%d mois",
				y: "un an",
				yy: "%d ans"
			},
			ordinal: function(e) {
				return "" + e + (e === 1 ? "er" : "");
			}
		};
		return n.default.locale(r, null, !0), r;
	}));
})), yi = /* @__PURE__ */ Kr(((e, t) => {
	(function(n, r) {
		typeof e == "object" && t !== void 0 ? t.exports = r() : typeof define == "function" && define.amd ? define(r) : (n = typeof globalThis < "u" ? globalThis : n || self).dayjs_plugin_calendar = r();
	})(e, (function() {
		return function(e, t, n) {
			var r = "h:mm A", i = {
				lastDay: "[Yesterday at] " + r,
				sameDay: "[Today at] " + r,
				nextDay: "[Tomorrow at] " + r,
				nextWeek: "dddd [at] " + r,
				lastWeek: "[Last] dddd [at] " + r,
				sameElse: "MM/DD/YYYY"
			};
			t.prototype.calendar = function(e, t) {
				var r = t || this.$locale().calendar || i, a = n(e || void 0).startOf("d"), o = this.diff(a, "d", !0), s = "sameElse", c = o < -6 ? s : o < -1 ? "lastWeek" : o < 0 ? "lastDay" : o < 1 ? "sameDay" : o < 2 ? "nextDay" : o < 7 ? "nextWeek" : s, l = r[c] || i[c];
				return typeof l == "function" ? l.call(this, n()) : this.format(l);
			};
		};
	}));
})), bi = /* @__PURE__ */ Kr(((e, t) => {
	(function(n, r) {
		typeof e == "object" && t !== void 0 ? t.exports = r() : typeof define == "function" && define.amd ? define(r) : (n = typeof globalThis < "u" ? globalThis : n || self).dayjs_plugin_customParseFormat = r();
	})(e, (function() {
		var e = {
			LTS: "h:mm:ss A",
			LT: "h:mm A",
			L: "MM/DD/YYYY",
			LL: "MMMM D, YYYY",
			LLL: "MMMM D, YYYY h:mm A",
			LLLL: "dddd, MMMM D, YYYY h:mm A"
		}, t = /(\[[^[]*\])|([-_:/.,()\s]+)|(A|a|YYYY|YY?|MM?M?M?|Do|DD?|hh?|HH?|mm?|ss?|S{1,3}|z|ZZ?)/g, n = /\d\d/, r = /\d\d?/, i = /\d*[^-_:/,()\s\d]+/, a = {}, o = function(e) {
			return (e = +e) + (e > 68 ? 1900 : 2e3);
		}, s = function(e) {
			return function(t) {
				this[e] = +t;
			};
		}, c = [/[+-]\d\d:?(\d\d)?|Z/, function(e) {
			(this.zone ||= {}).offset = function(e) {
				if (!e || e === "Z") return 0;
				var t = e.match(/([+-]|\d\d)/g), n = 60 * t[1] + (+t[2] || 0);
				return n === 0 ? 0 : t[0] === "+" ? -n : n;
			}(e);
		}], l = function(e) {
			var t = a[e];
			return t && (t.indexOf ? t : t.s.concat(t.f));
		}, u = function(e, t) {
			var n, r = a.meridiem;
			if (r) {
				for (var i = 1; i <= 24; i += 1) if (e.indexOf(r(i, 0, t)) > -1) {
					n = i > 12;
					break;
				}
			} else n = e === (t ? "pm" : "PM");
			return n;
		}, d = {
			A: [i, function(e) {
				this.afternoon = u(e, !1);
			}],
			a: [i, function(e) {
				this.afternoon = u(e, !0);
			}],
			S: [/\d/, function(e) {
				this.milliseconds = 100 * e;
			}],
			SS: [n, function(e) {
				this.milliseconds = 10 * e;
			}],
			SSS: [/\d{3}/, function(e) {
				this.milliseconds = +e;
			}],
			s: [r, s("seconds")],
			ss: [r, s("seconds")],
			m: [r, s("minutes")],
			mm: [r, s("minutes")],
			H: [r, s("hours")],
			h: [r, s("hours")],
			HH: [r, s("hours")],
			hh: [r, s("hours")],
			D: [r, s("day")],
			DD: [n, s("day")],
			Do: [i, function(e) {
				var t = a.ordinal, n = e.match(/\d+/);
				if (this.day = n[0], t) for (var r = 1; r <= 31; r += 1) t(r).replace(/\[|\]/g, "") === e && (this.day = r);
			}],
			M: [r, s("month")],
			MM: [n, s("month")],
			MMM: [i, function(e) {
				var t = l("months"), n = (l("monthsShort") || t.map((function(e) {
					return e.slice(0, 3);
				}))).indexOf(e) + 1;
				if (n < 1) throw Error();
				this.month = n % 12 || n;
			}],
			MMMM: [i, function(e) {
				var t = l("months").indexOf(e) + 1;
				if (t < 1) throw Error();
				this.month = t % 12 || t;
			}],
			Y: [/[+-]?\d+/, s("year")],
			YY: [n, function(e) {
				this.year = o(e);
			}],
			YYYY: [/\d{4}/, s("year")],
			Z: c,
			ZZ: c
		};
		function f(n) {
			for (var r = n, i = a && a.formats, o = (n = r.replace(/(\[[^\]]+])|(LTS?|l{1,4}|L{1,4})/g, (function(t, n, r) {
				var a = r && r.toUpperCase();
				return n || i[r] || e[r] || i[a].replace(/(\[[^\]]+])|(MMMM|MM|DD|dddd)/g, (function(e, t, n) {
					return t || n.slice(1);
				}));
			}))).match(t), s = o.length, c = 0; c < s; c += 1) {
				var l = o[c], u = d[l], f = u && u[0], p = u && u[1];
				o[c] = p ? {
					regex: f,
					parser: p
				} : l.replace(/^\[|\]$/g, "");
			}
			return function(e) {
				for (var t = {}, n = 0, r = 0; n < s; n += 1) {
					var i = o[n];
					if (typeof i == "string") r += i.length;
					else {
						var a = i.regex, c = i.parser, l = e.slice(r), u = a.exec(l)[0];
						c.call(t, u), e = e.replace(u, "");
					}
				}
				return function(e) {
					var t = e.afternoon;
					if (t !== void 0) {
						var n = e.hours;
						t ? n < 12 && (e.hours += 12) : n === 12 && (e.hours = 0), delete e.afternoon;
					}
				}(t), t;
			};
		}
		return function(e, t, n) {
			n.p.customParseFormat = !0, e && e.parseTwoDigitYear && (o = e.parseTwoDigitYear);
			var r = t.prototype, i = r.parse;
			r.parse = function(e) {
				var t = e.date, r = e.utc, o = e.args;
				this.$u = r;
				var s = o[1];
				if (typeof s == "string") {
					var c = !0 === o[2], l = !0 === o[3], u = c || l, d = o[2];
					l && (d = o[2]), a = this.$locale(), !c && d && (a = n.Ls[d]), this.$d = function(e, t, n) {
						try {
							if (["x", "X"].indexOf(t) > -1) return /* @__PURE__ */ new Date((t === "X" ? 1e3 : 1) * e);
							var r = f(t)(e), i = r.year, a = r.month, o = r.day, s = r.hours, c = r.minutes, l = r.seconds, u = r.milliseconds, d = r.zone, p = /* @__PURE__ */ new Date(), m = o || (i || a ? 1 : p.getDate()), h = i || p.getFullYear(), ee = 0;
							i && !a || (ee = a > 0 ? a - 1 : p.getMonth());
							var g = s || 0, te = c || 0, _ = l || 0, v = u || 0;
							return d ? new Date(Date.UTC(h, ee, m, g, te, _, v + 60 * d.offset * 1e3)) : n ? new Date(Date.UTC(h, ee, m, g, te, _, v)) : new Date(h, ee, m, g, te, _, v);
						} catch {
							return /* @__PURE__ */ new Date("");
						}
					}(t, s, r), this.init(), d && !0 !== d && (this.$L = this.locale(d).$L), u && t != this.format(s) && (this.$d = /* @__PURE__ */ new Date("")), a = {};
				} else if (s instanceof Array) for (var p = s.length, m = 1; m <= p; m += 1) {
					o[1] = s[m - 1];
					var h = n.apply(this, o);
					if (h.isValid()) {
						this.$d = h.$d, this.$L = h.$L, this.init();
						break;
					}
					m === p && (this.$d = /* @__PURE__ */ new Date(""));
				}
				else i.call(this, e);
			};
		};
	}));
})), xi = /* @__PURE__ */ Kr(((e, t) => {
	(function(n, r) {
		typeof e == "object" && t !== void 0 ? t.exports = r() : typeof define == "function" && define.amd ? define(r) : (n = typeof globalThis < "u" ? globalThis : n || self).dayjs_plugin_isBetween = r();
	})(e, (function() {
		return function(e, t, n) {
			t.prototype.isBetween = function(e, t, r, i) {
				var a = n(e), o = n(t), s = (i ||= "()")[0] === "(", c = i[1] === ")";
				return (s ? this.isAfter(a, r) : !this.isBefore(a, r)) && (c ? this.isBefore(o, r) : !this.isAfter(o, r)) || (s ? this.isBefore(a, r) : !this.isAfter(a, r)) && (c ? this.isAfter(o, r) : !this.isBefore(o, r));
			};
		};
	}));
})), Si = /* @__PURE__ */ Kr(((e, t) => {
	(function(n, r) {
		typeof e == "object" && t !== void 0 ? t.exports = r() : typeof define == "function" && define.amd ? define(r) : (n = typeof globalThis < "u" ? globalThis : n || self).dayjs_plugin_isLeapYear = r();
	})(e, (function() {
		return function(e, t) {
			t.prototype.isLeapYear = function() {
				return this.$y % 4 == 0 && this.$y % 100 != 0 || this.$y % 400 == 0;
			};
		};
	}));
})), Ci = /* @__PURE__ */ Kr(((e, t) => {
	(function(n, r) {
		typeof e == "object" && t !== void 0 ? t.exports = r() : typeof define == "function" && define.amd ? define(r) : (n = typeof globalThis < "u" ? globalThis : n || self).dayjs_plugin_timezone = r();
	})(e, (function() {
		var e = {
			year: 0,
			month: 1,
			day: 2,
			hour: 3,
			minute: 4,
			second: 5
		}, t = {};
		return function(n, r, i) {
			var a, o = function(e, n, r) {
				r === void 0 && (r = {});
				var i = new Date(e);
				return function(e, n) {
					n === void 0 && (n = {});
					var r = n.timeZoneName || "short", i = e + "|" + r, a = t[i];
					return a || (a = new Intl.DateTimeFormat("en-US", {
						hour12: !1,
						timeZone: e,
						year: "numeric",
						month: "2-digit",
						day: "2-digit",
						hour: "2-digit",
						minute: "2-digit",
						second: "2-digit",
						timeZoneName: r
					}), t[i] = a), a;
				}(n, r).formatToParts(i);
			}, s = function(t, n) {
				for (var r = o(t, n), a = [], s = 0; s < r.length; s += 1) {
					var c = r[s], l = c.type, u = c.value, d = e[l];
					d >= 0 && (a[d] = parseInt(u, 10));
				}
				var f = a[3], p = f === 24 ? 0 : f, m = a[0] + "-" + a[1] + "-" + a[2] + " " + p + ":" + a[4] + ":" + a[5] + ":000", h = +t;
				return (i.utc(m).valueOf() - (h -= h % 1e3)) / 6e4;
			}, c = r.prototype;
			c.tz = function(e, t) {
				e === void 0 && (e = a);
				var n = this.utcOffset(), r = this.toDate(), o = r.toLocaleString("en-US", { timeZone: e }), s = Math.round((r - new Date(o)) / 1e3 / 60), c = i(o, { locale: this.$L }).$set("millisecond", this.$ms).utcOffset(15 * -Math.round(r.getTimezoneOffset() / 15) - s, !0);
				if (t) {
					var l = c.utcOffset();
					c = c.add(n - l, "minute");
				}
				return c.$x.$timezone = e, c;
			}, c.offsetName = function(e) {
				var t = this.$x.$timezone || i.tz.guess(), n = o(this.valueOf(), t, { timeZoneName: e }).find((function(e) {
					return e.type.toLowerCase() === "timezonename";
				}));
				return n && n.value;
			};
			var l = c.startOf;
			c.startOf = function(e, t) {
				if (!this.$x || !this.$x.$timezone) return l.call(this, e, t);
				var n = i(this.format("YYYY-MM-DD HH:mm:ss:SSS"), { locale: this.$L });
				return l.call(n, e, t).tz(this.$x.$timezone, !0);
			}, i.tz = function(e, t, n) {
				var r = n && t, o = n || t || a, c = s(+i(), o);
				if (typeof e != "string") return i(e).tz(o);
				var l = function(e, t, n) {
					var r = e - 60 * t * 1e3, i = s(r, n);
					if (t === i) return [r, t];
					var a = s(r -= 60 * (i - t) * 1e3, n);
					return i === a ? [r, i] : [e - 60 * Math.min(i, a) * 1e3, Math.max(i, a)];
				}(i.utc(e, r).valueOf(), c, o), u = l[0], d = l[1], f = i(u).utcOffset(d);
				return f.$x.$timezone = o, f;
			}, i.tz.guess = function() {
				return Intl.DateTimeFormat().resolvedOptions().timeZone;
			}, i.tz.setDefault = function(e) {
				a = e;
			};
		};
	}));
})), wi = /* @__PURE__ */ Kr(((e, t) => {
	(function(n, r) {
		typeof e == "object" && t !== void 0 ? t.exports = r() : typeof define == "function" && define.amd ? define(r) : (n = typeof globalThis < "u" ? globalThis : n || self).dayjs_plugin_utc = r();
	})(e, (function() {
		var e = "minute", t = /[+-]\d\d(?::?\d\d)?/g, n = /([+-]|\d\d)/g;
		return function(r, i, a) {
			var o = i.prototype;
			a.utc = function(e) {
				return new i({
					date: e,
					utc: !0,
					args: arguments
				});
			}, o.utc = function(t) {
				var n = a(this.toDate(), {
					locale: this.$L,
					utc: !0
				});
				return t ? n.add(this.utcOffset(), e) : n;
			}, o.local = function() {
				return a(this.toDate(), {
					locale: this.$L,
					utc: !1
				});
			};
			var s = o.parse;
			o.parse = function(e) {
				e.utc && (this.$u = !0), this.$utils().u(e.$offset) || (this.$offset = e.$offset), s.call(this, e);
			};
			var c = o.init;
			o.init = function() {
				if (this.$u) {
					var e = this.$d;
					this.$y = e.getUTCFullYear(), this.$M = e.getUTCMonth(), this.$D = e.getUTCDate(), this.$W = e.getUTCDay(), this.$H = e.getUTCHours(), this.$m = e.getUTCMinutes(), this.$s = e.getUTCSeconds(), this.$ms = e.getUTCMilliseconds();
				} else c.call(this);
			};
			var l = o.utcOffset;
			o.utcOffset = function(r, i) {
				var a = this.$utils().u;
				if (a(r)) return this.$u ? 0 : a(this.$offset) ? l.call(this) : this.$offset;
				if (typeof r == "string" && (r = function(e) {
					e === void 0 && (e = "");
					var r = e.match(t);
					if (!r) return null;
					var i = ("" + r[0]).match(n) || [
						"-",
						0,
						0
					], a = i[0], o = 60 * i[1] + +i[2];
					return o === 0 ? 0 : a === "+" ? o : -o;
				}(r), r === null)) return this;
				var o = Math.abs(r) <= 16 ? 60 * r : r, s = this;
				if (i) return s.$offset = o, s.$u = r === 0, s;
				if (r !== 0) {
					var c = this.$u ? this.toDate().getTimezoneOffset() : -1 * this.utcOffset();
					(s = this.local().add(o + c, e)).$offset = o, s.$x.$localOffset = c;
				} else s = this.utc();
				return s;
			};
			var u = o.format;
			o.format = function(e) {
				var t = e || (this.$u ? "YYYY-MM-DDTHH:mm:ss[Z]" : "");
				return u.call(this, t);
			}, o.valueOf = function() {
				var e = this.$utils().u(this.$offset) ? 0 : this.$offset + (this.$x.$localOffset || this.$d.getTimezoneOffset());
				return this.$d.valueOf() - 6e4 * e;
			}, o.isUTC = function() {
				return !!this.$u;
			}, o.toISOString = function() {
				return this.toDate().toISOString();
			}, o.toString = function() {
				return this.toDate().toUTCString();
			};
			var d = o.toDate;
			o.toDate = function(e) {
				return e === "s" && this.$offset ? a(this.format("YYYY-MM-DD HH:mm:ss:SSS")).toDate() : d.call(this);
			};
			var f = o.diff;
			o.diff = function(e, t, n) {
				if (e && this.$u === e.$u) return f.call(this, e, t, n);
				var r = this.local(), i = a(e).local();
				return f.call(r, i, t, n);
			};
		};
	}));
}));
gi(), _i(), vi();
var Ti = /* @__PURE__ */ Jr(hi(), 1), Ei = /* @__PURE__ */ Jr(yi(), 1), Di = /* @__PURE__ */ Jr(bi(), 1), Oi = /* @__PURE__ */ Jr(xi(), 1), ki = /* @__PURE__ */ Jr(Si(), 1), Ai = /* @__PURE__ */ Jr(Ci(), 1), ji = /* @__PURE__ */ Jr(wi(), 1);
Ti.default.extend(Di.default), Ti.default.extend(ki.default), Ti.default.extend(Ei.default), Ti.default.extend(ji.default), Ti.default.extend(Oi.default), Ti.default.extend(Ai.default), Ti.default.locale("nl"), Ti.default.tz.setDefault("Europe/Amsterdam"), Ti.default;
/* c8 ignore start */
var Mi = {
	getWeightFactor: (e) => {
		switch (e) {
			case "g":
			case $r.Gram:
			case Qr.Gram: return ei[$r.Gram];
			case $r.Kilogram:
			case Qr.Kilogram: return ei[$r.Kilogram];
			default: throw Error(`Unknown weight unit: ${e}`);
		}
	},
	transformMetersToKilometers: (e) => {
		let t = e / 1e3;
		return t % 1 == 0 ? t : parseFloat(t.toFixed(1));
	}
}, Ni = (e, t) => {
	let n;
	switch (t) {
		case hr.Gram:
			n = e;
			break;
		default:
			n = Mi.getWeightFactor(t) * e;
			break;
	}
	return {
		value: n,
		unit: "g"
	};
}, Pi = (e) => {
	switch (e.unit) {
		case "g": return e.value;
		case "kg": return e.value * Mi.getWeightFactor("kg");
		default: return e.value;
	}
}, Fi = Object.values(xn).filter((e) => e !== xn.DISCOVERED), Ii = (e) => e === xn.DISCOVERED || e === xn.IMPORT_REQUESTED, Li = Object.values(xn).filter((e) => !Ii(e)), Ri = (e) => e === xn.CANCELED, zi = (e) => e === xn.IMPORT_REQUESTED;
//#endregion
export { Ar as ADJUSTED_DELIVERY_TYPES, Fr as ADJUSTED_PICKUP_TYPES, un as AddPackagesSchema, qn as AddressSchema, $n as BillingDetailsSchema, gn as Carrier, mn as CarrierSchema, jn as CarrierToCreate, Zn as CarrierToCreateSchema, en as ContactBusinessSchema, Lt as ContactMultiEmailBusinessSchema, Yn as ContactMultiEmailPrivateSchema, nn as ContactMultiEmailSchema, Bt as ContactPrivateSchema, zt as ContactSchema, Xt as CountryCodeSchema, An as CreateOrderFromShippablePackagesSchema, Ft as CustomerReferenceSchema, or as CustomsDeclarationPurpose, kn as CustomsDeclarationResponseSchema, Jt as CustomsDeclarationSchema, Yt as DeliveryOptionsSchema, Zt as DeliverySchema, x as DeliveryType, Vt as DeliveryTypeSchema, Wt as DropOffSchema, qt as ExternalReferenceEcommercePlatformSchema, $t as ExternalReferenceSalesChannelSchema, tr as ExternalReferencesImportSchema, It as ExternalReferencesMyParcelShopSchema, an as ExternalReferencesSalesChannelSchema, Ut as ExternalReferencesSchema, vn as GeoAreaCode, rn as GeoAreaCodeSchema, on as LabelWithBarcodeSchema, Ht as LabelWithoutBarcodeSchema, Kt as LineExternalReferenceSchema, Bn as LineSchema, Gt as MoneySchema, cn as NoteFromImportedSchema, sn as NoteFromPrincipalSchema, ln as NoteSchema, Qt as OrderSchema, xn as OrderStatus, Pt as OrderStatusSchema, bn as PackageCommonSchema, Gn as PackageRequestSchema, In as PackageResponseSchema, sr as PackageStatusGroup, Hn as PackageStatusSchema, Rn as PackageType, On as PackageTypeSchema, Nn as PaymentStatus, pn as PaymentStatusSchema, Ln as PhysicalPropertiesSchema, Un as PhysicalPropertiesWeightRequiredSchema, _n as PickupSchema, Mn as PreparePackagesForShipmentPackageSchema, Kn as PreparePackagesForShipmentSchema, yn as ProblemDetailsClientSchema, Sn as ProblemDetailsInternalServerErrorSchema, zn as ProblemDetailsInvalidRequestSyntaxSchema, Pn as ProblemDetailsSchema, En as RegionCodeSchema, Tn as ShipmentDirection, wn as ShipmentDirectionSchema, dn as ShipmentOptionsCommonSchema, Jn as ShipmentOptionsPackageSchema, er as ShipmentOptionsSchema, hn as ShipmentRequestSchema, Qn as ShipmentSchema, tn as ShippablePackageSchema, Rt as ShippingSchema, Cn as SortDirection, Xn as SortDirectionSchema, Li as activeOrderStatuses, Fi as allStatusesExceptDiscovered, jr as deliveryTypeV1ToV2, Mr as deliveryTypeV2ToV1, ir as events, yt as getOrders, ot as getPackingSlips, ht as getPicklist, Ir as isAdjustedDeliveryType, Lr as isAdjustedPickupType, cr as isBusinessContact, Wn as isCreateMulticolloShippablePackage, Fn as isCreateShippablePackage, Ii as isDiscoverableOrderStatus, ur as isLabelWithBarcode, dr as isLabelWithoutBarcode, Ri as isOrderCanceled, zi as isOrderImportRequested, lr as isPrivateContact, Vn as isShipPackagesAsMulticollo, Dn as isShipPackagesRequest, Pi as mapServiceWeightToGrams, Ni as mapWeightToService, ar as matchOrderEvent, zr as moneyFromMicros, Rr as moneyToMicros, bt as orderApiAcceptanceUrl, st as orderApiUrl, Xe as postAddNote, Fe as postAddPackages, lt as postAssignToUser, _t as postCancel, ze as postCreateFromShippablePackages, nt as postEditNote, St as postEvaluateRules, Ve as postImport, We as postPreparePackagesForShipment, dt as postRemoveNotes, it as postUnassignFromUser, Je as postUnpreparePackagesForShipment, Nr as toDeliveryTypeV1, Pr as toDeliveryTypeV2, nr as useOrderService, Ke as zAddPackages, Ne as zAddress, wt as zBillingDetails, At as zCarrier, Le as zCarrierToCreate, Ot as zContact, _e as zContactBusiness, o as zContactMultiEmail, Et as zContactMultiEmailBusiness, ye as zContactMultiEmailPrivate, u as zContactPrivate, c as zCountryCode, le as zCreateOrderFromShippablePackages, et as zCustomerReference, n as zCustomsDeclaration, Qe as zCustomsDeclarationResponse, ae as zDelivery, se as zDeliveryOptions, de as zDeliveryType, f as zDropOff, te as zExternalReferenceEcommercePlatform, y as zExternalReferenceSalesChannel, he as zExternalReferences, Mt as zExternalReferencesImport, i as zExternalReferencesMyParcelShop, Ce as zExternalReferencesSalesChannel, ee as zGeoAreaCode, xe as zGetOrdersData, Te as zGetOrdersResponse, m as zGetPackingSlipsData, re as zGetPackingSlipsResponse, pt as zGetPicklistData, v as zGetPicklistResponse, ke as zLabelWithBarcode, De as zLabelWithoutBarcode, je as zLine, pe as zLineExternalReference, e as zMoney, Ue as zNote, xt as zNoteFromImported, ct as zNoteFromPrincipal, gt as zOrder, Ze as zOrderStatus, Ie as zPackageCommon, ut as zPackageRequest, vt as zPackageResponse, Be as zPackageStatus, rt as zPackageType, Ct as zPaymentStatus, He as zPhysicalProperties, Ge as zPhysicalPropertiesWeightRequired, ft as zPickup, at as zPostAddNoteData, Ye as zPostAddNoteResponse, qe as zPostAddPackagesData, Pe as zPostAddPackagesResponse, Tt as zPostAssignToUserData, jt as zPostAssignToUserResponse, Re as zPostCancelData, kt as zPostCancelResponse, ve as zPostCreateFromShippablePackagesData, s as zPostCreateFromShippablePackagesResponse, Dt as zPostEditNoteData, be as zPostEditNoteResponse, d as zPostEvaluateRulesData, l as zPostEvaluateRulesResponse, ue as zPostImportData, tt as zPostImportResponse, r as zPostPreparePackagesForShipmentData, $e as zPostPreparePackagesForShipmentResponse, oe as zPostRemoveNotesData, ce as zPostRemoveNotesResponse, fe as zPostUnassignFromUserData, p as zPostUnassignFromUserResponse, _ as zPostUnpreparePackagesForShipmentData, b as zPostUnpreparePackagesForShipmentResponse, ge as zPreparePackagesForShipment, Nt as zPreparePackagesForShipmentPackage, a as zProblemDetails, we as zProblemDetailsClient, g as zProblemDetailsInternalServerError, Se as zProblemDetailsInvalidRequestSyntax, Ee as zRegionCode, h as zShipment, ie as zShipmentDirection, mt as zShipmentOptions, ne as zShipmentOptionsCommon, Ae as zShipmentOptionsPackage, Oe as zShipmentRequest, Me as zShippablePackage, me as zShipping, t as zSortDirection };
